import React, { useState,useEffect,useRef, useCallback, useMemo } from 'react';
import Agingoptions from './Agingoptions/Agingoptions';
import LifepointLaw from './Life_point_law/LifepointLaw';
import {Services} from '../network/Services';
import { runAmaSubscriptionChain } from '../network/amaSubscription';
import { getLoggedUserId, setLoggedUserId, resolveLoggedUserIdFromPayload } from '../network/auditFields';
import PaymentGateWay from './PaymentGateWay';
import Toaster from './Toaster';
import Loader from './Loader';
import { appendFormData, capitalizeFirst, createNestedArray, demo,formatDateToMMDDYY, federal_way_plazaId, formatDateIntoDDMMYY, formatDatePDT, formatPhoneNumber, formatToUS, getApiCall, isNotValidNullUndefile, isNullUndefine, isValidFuntion,lplSubtinent,receiptCashpayment,reportViewableUserIds,receiptCashpaymentGeneral,receiptCashpaymentIOLTA,time_mattersSubtinent, isNotValidNullUndefileInstallmentAmount, removeCommas, getTodayDateUSFormat,formatDateLocal, formatDateLocalPST } from '../control/Constant';
import FederalWay from './FederalWay/FederalWay';
import { useNavigate } from 'react-router-dom';
import {useConfirm} from "./ConfirmationToaster";
import html2canvas from 'html2canvas';
import AoUrl, { CounterBaseUrl, intakeBaseUrl ,BASE_URL_New} from '../network/url';
import konsole from '../network/konsole';
import CardDetails from './CardDetails';
import jsPDF from 'jspdf';
import TopHead from './TopHead';
import config from '../config.json'
import ExcleDashbord from './ExcleReport/ExcleDashbord';
import html2pdf from "html2pdf.js";
import * as pako from "pako";
import Refund from './Refund';
import RefundNotification from './RefundNotification';
// import ExcleDashbord from './ExcleReport/ExcleDashbord';
const safeJSON = (value, fallback = null) => {
  if (value === null || value === undefined || value === "undefined") return fallback;
  try { return JSON.parse(value); }
  catch { return fallback; }
};

const Dashboard = (props) => {
  let companyName = sessionStorage.getItem('companyName');
  const [selectedCompany, setSelectedCompany] = useState(companyName || '');
  const [selectedUserData, setSelectedUserData] = useState()
  let userDeatils = safeJSON(sessionStorage.getItem('userDeatils')) || {};
  let isClient = safeJSON(sessionStorage.getItem('isClient'));
  let sessionSubtenantId = sessionStorage.getItem('SubtenantId');
  const [orderIdData, setOrderIdData] = useState()
  const [confirmOrderDetails, setConfirmOrderDetails] = useState()
  const [toast, setToast] = useState(null);
  const [openRecipetModal,setOpenRecipetModal] = useState(false)
  const [invoiceHtml, setInvoiceHtml] = useState('');
  const [stateShow,setStateShow]=useState("")
  const [finalIntallmentMethod, setFinalIntallmentMethod] = useState('')
  const [isPayButton, setIsPayButton] = useState(false);
  const invoiceRef = useRef(null);
  let subtenantName = sessionStorage.getItem('subtenantName');
  const msg = "Thank you! Your payment has been received successfully."
  const toNumber = (value) =>  Number(String(value).replace(/[^\d.-]/g, ""));
  const [paymentData, setPaymentData] = useState({
    company: '',
    lineOfBusiness: '',
    matterNumber: '',
    clientInfo: null,
    amount: null,
    paymentMethod: '',
    // paymentDate: new Date().toISOString().split('T')[0],
    paymentDate:null,
    description: '',
    components: [],
    businessName:'',
    businessName:'',
    checkNumber :"",
    payAmount:null,
    installmentFrequencies:'-1',
    installmentDate:'',
    installmentNumber:'',
    subscriptionName : '',
    responsibleAttorney :'',
    originatingAttorney : '',
    checkDate:'',
    serviceMatNo:'',
    totalDiscount: null,
  });

  const [useLoader, setuseLoader] = useState(false)
  const navigate = useNavigate()
  // Save the original login subtenant once — before any company switching
  const originalLoginSubtenantId = useRef(sessionStorage.getItem('SubtenantId'));
  const [installmentpay,setInstallmentpay] = useState('')
  const [installmentAmount,setInstallmentamount] = useState(0)
  const confirm = useConfirm();
  const keyNameObj = {'amount':'total amount','installmentDate':'installment date','installmentFrequencies':'installment frequencies','installmentNumber':'installments','payAmount': 'Initial Payment'}
  const [showAddCard,setShowaddcard] = useState(false)
  const [PaymentOption,setPaymentoption] = useState(1)
  const scrollRef = useRef(null)
  const [timeMatter, setTimematter] = useState(false);
  const [paymentAccount,setPaymentaccount] = useState([])
  const [isUpdated ,setIsUpdated] = useState(false)
  let isOtpVarified = safeJSON(sessionStorage.getItem('isOtpVarified'));
  let userRegistration = safeJSON(sessionStorage.getItem('userRegistration'));
  let SubtenantIde = safeJSON(sessionStorage.getItem('SubtenantId'));
  let userRegistred = safeJSON(sessionStorage.getItem('userRegistred'));
  const [payLatter, setPayLatter] = useState(false)
  const contentRef = useRef();
  const [pdfFile,setPdffile] = useState('')
  const [legalCategoryLifePlanFolderId, setLegalCategoryLifePlanFolderId] = useState([])
  const [allFolderList, setAllFolderList] = useState([])
  const [showExcle, setShowExcle] = useState(false)
  const [subtenantIdExcel,setSubtenantIdExcel] = useState()
  const loggedUserId = getLoggedUserId();
  const isReportViewable = reportViewableUserIds?.some((id => id?.toLowerCase() === loggedUserId?.toLowerCase()));
  const [splitCards,setSplitcards] = useState([{id:1,amount:0}])
  const [queryData, setQueryData] = useState(null);
  const [queryData22, setQueryData22] = useState(null);
  const [isQueryDataLoaded, setIsQueryDataLoaded] = useState(false);
  const [userAuthSubIdState, setUserAuthSubIdState] = useState(null);
  const [subsDetails, setSubsDetails] = useState(null);
  const [splitPaymentno, setSplitPaymentno] = useState('No');
  const [errorMesSplit, setErrorMesSplit] = useState('');
  const [issplitPaymentSession,setIsSplitpaymentsession] = useState(false)
  const [trxnStatus,setTrxnStatus] = useState('')
  const [isProcessing, setIsProcessing] = useState(false);
  const [recurringCard,setRecurringCard] = useState('')
  const [scheduleCard,setScheculeCard] = useState('')
  const [recurringCardAMA,setRecurringCardAMA] = useState('')
  const [recurringCardAMAfee,setRecurringCardAMAfee] = useState('')
  const otherSourceref = useRef(null)
  const [addnewService,setAddnewservice] = useState(false)

  const servicetyperef = useRef(null)
  // const containerRef = useRef(null);
  const [userAccess,setUserAccess] = useState()
  const [refundRefreshTrigger, setRefundRefreshTrigger] = useState(0)

  const todayLocal = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
    // return `2024-04-12`;
  };

  const incrementSplitCardNumber = () => {
    setPaymentData(prev => ({
      ...prev,
      splitCardnumber: (prev.splitCardnumber || 0) + 1
    }));
  };

  useEffect(()=>{
    fetchRole()
    setPaymentData((prev)=>({...prev,"paymentDate":(todayLocal() || null)}))
  },[])

  const fetchRole = async () => {
      let loggedInUserId = sessionStorage.getItem('loggedUserId')
      if(!loggedInUserId) return;
      const _resultOf = await Services.getUserRolesByUserId(loggedInUserId);
      if (_resultOf != 'err' && _resultOf?.data?.length > 0) {
          const resData = _resultOf?.data[0];
          let userAccess = {userId:resData?.userId,userFullName:resData?.userFullName,isRecordAccess:resData?.isRecordAccess,isRefundAccess:resData?.isRefundAccess}
          sessionStorage.setItem('userAccess',JSON.stringify(userAccess))
          setUserAccess(userAccess)
      }
  }

  // Callback to handle refund updates from RefundNotification
  const handleRefundUpdate = () => {
    setRefundRefreshTrigger(prev => prev + 1);
  }





  const decodeFromUrlSafeBase64 = s => JSON.parse(pako.inflate(Uint8Array.from(atob(s.replace(/-/g,'+').replace(/_/g,'/')), c=>c.charCodeAt(0)), {to:'string'}));

  useEffect(() => {
    handleDecodeQueryData();
  }, []);

  useEffect(() => {
    const cameFromGateway = sessionStorage.getItem("isCameFromPaymentGateWay") === "true";
    let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
    const storedData = JSON.parse(sessionStorage.getItem("queryData") || "{}");
    if (cameFromGateway) {
      const storedData = JSON.parse(sessionStorage.getItem("queryData") || "{}");
      setQueryData(storedData);
      // if(issplitPayment != true){
      // sessionStorage.removeItem("queryData");
      // }
    }else{
      setQueryData(storedData);
    }
  }, []);

  // useEffect(()=>{
  // if(paymentData?.paymentMethod != 'credit'){
  //   setSplitPaymentno('No')
  //   setSplitcards([{id:1,amount:0}]);
  // }
  // },[paymentData?.paymentMethod != 'credit'])

  const handleDecodeQueryData = async() => {
    const queryParams = new URLSearchParams(window.location.search);
    const encodedData = queryParams.get("moConId");
    if (encodedData) {
      sessionStorage.removeItem('PaymentMethod')
      sessionStorage.removeItem('userDeatils')
      sessionStorage.removeItem('orderId')
      sessionStorage.removeItem('userAuthSubId')
      sessionStorage.removeItem('feedBackUserID')
      sessionStorage.removeItem('feedBackCreatedBy')
      sessionStorage.removeItem('feedBackuserLoggedInDetail')
      sessionStorage.removeItem('userPaymentTypeandAuth')
      sessionStorage.removeItem('recursionData')
      sessionStorage.removeItem('queryData')
      let responseModuleconnectapi = await getModuleConnectApi(encodedData)
      const decodedData = JSON.parse(responseModuleconnectapi)
      setLoggedUserId(resolveLoggedUserIdFromPayload(decodedData));
      const productList = decodedData?.clientOrderDetails?.productList || [];
      const hasPortalProduct = productList?.some(
        (p) => p.productName === "Annual Maintenance Agreement - Portal"
      );
      const userID = decodedData.UserID || decodedData.UserId;
      if (decodedData?.paymnetFromEventCoordinator !== 'true') {
        let resolvedSubscriptionId = decodedData?.subscriptionId;
        if (resolvedSubscriptionId == null) {
          const subsList = decodedData?.clientParaData?.userSubscriptionDeatils || [];
          if (decodedData?.refrencePage === "AMA_ADVANCE") {
            resolvedSubscriptionId = subsList?.find(s => s.subscriptionId === 1)?.subscriptionId
              ?? subsList[0]?.subscriptionId;
          } else {
            resolvedSubscriptionId = subsList[0]?.subscriptionId;
          }
        }

        const subData = await fetchUserSubscription({
          subtenantId: decodedData.subtenantId,
          subscriptionId: resolvedSubscriptionId,
          userID: userID,
        });

        setQueryData({
          ...decodedData,
          subsDetails: subData,
          subscriptionType: decodedData?.refrencePage === "AMA_ADVANCE" ? "advancePayment" : decodedData?.subscriptionType,
        });
         if (hasPortalProduct) {
           const subData22 = await fetchUserSubscription({
             subtenantId: decodedData.subtenantId,
             subscriptionId: 22,
             userID: userID,
           });
           setQueryData22({ ...decodedData, subsDetails: subData22 });
       }
        }else{
             setQueryData({ ...decodedData});
        }
      sessionStorage.setItem("feedBackUserID", decodedData?.UserId);
      sessionStorage.setItem("feedBackCreatedBy", decodedData?.createdBy);
      sessionStorage.setItem("feedBackuserLoggedInDetail", JSON.stringify(decodedData?.userLoggedInDetail));
      sessionStorage.setItem('isAdvancePayment', decodedData?.refrencePage === "AMA_ADVANCE");
    }
    setIsQueryDataLoaded(true);
  }

  const getModuleConnectApi = async (moConId) => {
    setuseLoader(true)
    const getModuleConnectparams = await Services.getModuleConnectservice(moConId)
    setuseLoader(false)
    if(getModuleConnectparams != 'err'){
      return getModuleConnectparams?.data[0]?.moduleConnectionRequest
    }

  }

  const fetchUserSubscription = async ({ subtenantId, subscriptionId, userID }) => {
    const res = await Services.getUserSubscription(subtenantId, subscriptionId, userID);

    const data = res?.data?.data || null;
    setSubsDetails(data);
    return data;
  };

  // Builds the AMA (subscriptionId 1) subscription payload from the current form fields.
  // validityFrom = payment date; futurePayDate = validityFrom + 1 year; orderId = payment order id.
  const buildAmaSubscriptionPayload = ({ subtenantId, userID, overrides, orderId }) => {
    // Payload date format expected as MM-DD-YYYY (todayLocal() returns YYYY-MM-DD).
    const toMMDDYYYY = (d) => {
      if (!isValidFuntion(d)) return (todayLocal() ? todayLocal().split('-').slice(1).concat(todayLocal().split('-')[0]).join('-') : null);
      const parts = String(d).split('-');
      return parts.length === 3 ? `${parts[1]}-${parts[2]}-${parts[0]}` : String(d);
    };
    // Adds exactly one year to a MM-DD-YYYY date string.
    const addOneYear = (mmddyyyy) => {
      if (!isValidFuntion(mmddyyyy)) return mmddyyyy;
      const parts = String(mmddyyyy).split('-');
      if (parts.length !== 3) return mmddyyyy;
      const [mm, dd, yyyy] = parts;
      return `${mm}-${dd}-${String(Number(yyyy) + 1)}`;
    };
    const toNumber = (v) => {
      if (v == null) return null;
      const n = parseFloat(String(v).replace(/,/g, ''));
      return isNaN(n) ? null : n;
    };
    const payDate = toMMDDYYYY(paymentData?.paymentDate);
    const futurePayDate = null;              // futurePayDate is always null
    const validityToDate = addOneYear(payDate); // validityTo = validityFrom + 1 year (a date)
    // Prefer explicit overrides (card flow paymentData may be stale), else live form state.
    const ov = overrides || {};
    const responsibleAttorney = ov.responsibleAttorney || paymentData?.responsibleAttorney || null;
    const originatingAttorney = ov.originatingAttorney || paymentData?.originatingAttorney || null;
    const paid = toNumber(ov.payAmount ?? paymentData?.payAmount) ?? toNumber(ov.amount ?? paymentData?.amount);
    const amount = toNumber(ov.amount ?? paymentData?.amount) ?? paid;
    const createdById = loggedUserId || null;
    // Selected service type. AMA (Annual Maintenance Agreement) => lineOfBusiness/subscriptionId 1.
    // Only for AMA send subscriptionId "1"; for any other service type send null.
    const selectedServiceType = ov.lineOfBusiness ?? paymentData?.lineOfBusiness;
    const isAma = Number(selectedServiceType) === 1;
    const subscriptionIdValue = isAma ? "1" : null;
    const json = {
      userId: userID,
      attorneyId: responsibleAttorney,            // Responsible Attorney
      originatingAttorneyId: originatingAttorney,  // Originating Staff
      clientAcquisitionManagerId: null,
      isActive: true,
      subsStatusId: 1,
      subscriptionId: subscriptionIdValue,         // "1" for AMA, else null
      amaFromAR: isAma ? true : false,             // true when paying for AMA
      subtenantId: subtenantId,
      orderId: orderId ?? null,                    // payment order id
      validityFrom: payDate,
      futurePayDate: futurePayDate,                // validityFrom + 1 year
      createdBy: createdById,
      totalAmount: amount,                         // from payment amount
      totalPaid: paid,                             // from payment amount
      validityTo: validityToDate,
      missedRenewals: null,
      modifidyFeeStruture: null,
    };
    return { json, amount };
  };

  // Adds OR updates an AMA subscription:
  //  - if an existing subscription record is found (existingUserSubscriptionId), PUT /update
  //    (payload includes userSubscriptionId);
  //  - otherwise POST /add (response.data = new userSubscriptionId).
  // Returns { userSubscriptionId, amount } or null (non-blocking).
  const addOrUpdateAmaSubscription = async ({ subtenantId, userID, overrides, orderId, existingUserSubscriptionId }) => {
    try {
      if (!isValidFuntion(userID)) return null;
      const { json, amount } = buildAmaSubscriptionPayload({ subtenantId, userID, overrides, orderId });
      konsole.log("addOrUpdateAmaSubscription payload (orderId:", orderId, "):", json);
      if (isValidFuntion(existingUserSubscriptionId)) {
        // Subscription already exists -> update it (sets orderId etc.).
        const updateJson = { ...json, userSubscriptionId: existingUserSubscriptionId, updatedBy: loggedUserId || null };
        await Services.updateUserSubscription(updateJson);
        return { userSubscriptionId: existingUserSubscriptionId, amount };
      }
      // New subscription -> add. Response data carries the new userSubscriptionId.
      const res = await Services.addUserSubscription(json);
      const newUserSubscriptionId = res?.data?.data ?? null;
      // The add endpoint does not persist orderId, so immediately update the new
      // record with the orderId (and other fields) so it is stored on first payment too.
      if (isValidFuntion(newUserSubscriptionId) && isValidFuntion(orderId)) {
        const updateJson = { ...json, userSubscriptionId: newUserSubscriptionId, updatedBy: loggedUserId || null };
        await Services.updateUserSubscription(updateJson);
      }
      return { userSubscriptionId: newUserSubscriptionId, amount };
    } catch (e) {
      konsole.log("add/updateUserSubscription (receipt) failed:", e);
      return null;
    }
  };

  // Picks the matching SKU from the Subscription/Details response: the one whose
  // endSubscriptionAmt equals the payment amount. Returns the SKU object or null.
  const pickSkuByAmount = (detailsRes, amount) => {
    const amt = (() => {
      if (amount == null) return null;
      const n = parseFloat(String(amount).replace(/,/g, ''));
      return isNaN(n) ? null : n;
    })();
    const detail = detailsRes?.data?.data?.[0];
    const allSkus = (detail?.subsPlans || []).flatMap((pl) => pl?.subsPlanSKUs || []);
    if (!allSkus.length) return null;
    if (amt == null) return null;
    return allSkus.find((s) => Number(s?.endSubscriptionAmt) === amt) || null;
  };

  // Builds + upserts the AMA subscription plan.
  //   Step A: Subscription/Details/{subtenantId}/1 -> master SKU list.
  //   Step B: pick the SKU whose endSubscriptionAmt matches the payment amount.
  //   Step C: UserSubscriptionPlans/upsert with that SKU (userSubsPlanId null on first create).
  // Returns the upsert response or null. Guarded + non-blocking.
  const upsertAmaSubscriptionPlans = async ({ subtenantId, userSubscriptionId, amount }) => {
    try {
      if (!isValidFuntion(userSubscriptionId)) {
        konsole.log("upsertAmaSubscriptionPlans skipped: missing userSubscriptionId");
        return null;
      }
      // Step A: subscription (AMA = 1) details.
      const detailsRes = await Services.getSubscriptionDetails(subtenantId, 1);
      // Step B: match SKU by amount.
      const sku = pickSkuByAmount(detailsRes, amount);
      konsole.log("Subscription/Details matched SKU for amount", amount, ":", sku);
      if (!sku) {
        konsole.log("upsertAmaSubscriptionPlans skipped: no SKU matched amount", amount);
        return null;
      }
      // Step C: upsert the plan.
      const payload = [{
        userSubscriptionId: userSubscriptionId,
        userSubsPlanId: null,
        subsPlanSKUMapId: sku?.subsPlanSKUMapId,
        isActive: true,
        upsertedBy: loggedUserId || null,
        subtenantRateCardId: sku?.subtenantRateCardId,
      }];
      return await Services.upsertUserSubscriptionPlans(payload);
    } catch (e) {
      konsole.log("upsertAmaSubscriptionPlans (receipt) failed:", e);
      return null;
    }
  };

  // Runs the full AMA receipt chain in the correct order:
  //  0. getUserSubscription (check if a record already exists)
  //  1. add (new) OR update (existing)  -> yields userSubscriptionId
  //  2. Subscription/Details -> pick SKU by amount
  //  3. UserSubscriptionPlans/upsert
  //  4. getUserSubscription (confirm)
  //  5. GetUserSubscriptionPlansAsync
  const runAmaReceiptChain = async ({ subtenantId, userID, overrides, orderId }) => {
    try {
      if (!isValidFuntion(userID)) return;
      // Only run this chain for AMA (Annual Maintenance Agreement). For any other
      // service type, do nothing — no API should be hit at all.
      const selectedServiceType = overrides?.lineOfBusiness ?? paymentData?.lineOfBusiness;
      if (Number(selectedServiceType) !== 1) {
        return;
      }
      // Step 0: check for an existing AMA subscription for this user.
      const existing = await fetchUserSubscription({ subtenantId, subscriptionId: 1, userID });
      const existingUserSubscriptionId = Array.isArray(existing) ? existing?.[0]?.userSubscriptionId : existing?.userSubscriptionId;
      // Step 1: add (new) or update (existing).
      const result = await addOrUpdateAmaSubscription({ subtenantId, userID, overrides, orderId, existingUserSubscriptionId });
      const userSubscriptionId = result?.userSubscriptionId ?? existingUserSubscriptionId ?? null;
      const amount = result?.amount ?? null;
      // Step 2+3: Subscription/Details -> pick SKU by amount -> upsert plan.
      await upsertAmaSubscriptionPlans({ subtenantId, userSubscriptionId, amount });
      // Step 4: fetch the subscription record (confirm).
      await fetchUserSubscription({ subtenantId, subscriptionId: 1, userID });
      // Step 5: fetch the (now created) user subscription plans.
      if (isValidFuntion(userSubscriptionId)) {
        await Services.getUserSubscriptionPlansAsync(userSubscriptionId, true);
      }
    } catch (e) {
      konsole.log("runAmaReceiptChain (receipt) failed:", e);
    }
  };

  useEffect(() => {
    if(queryData == null) return;
    if(queryData?.paymnetFromEventCoordinator  == 'true'){
   const updatedPayment = {
      lineOfBusiness: queryData?.lineOfBusiness,
      matterNumber: "",
      clientInfo: null,
      subscriptionName:queryData?.subscriptionName,
      amount: queryData?.totalCost?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) || null,
      paymentDate:(todayLocal() || null),
      components: [],
      checkNumber: "",
      installmentFrequencies: "-1",
      installmentDate: "",
      originatingAttorney:queryData?.originatingStaffId
    };
      setPaymentData((prev) => {if (JSON.stringify(prev) === JSON.stringify(updatedPayment)) return prev; return updatedPayment});
    }
    if (queryData?.paymnetFromIntake !== "true") return;
    const subs = queryData?.subsDetails?.[0];
    const order = queryData?.clientOrderDetails;
    const client = queryData?.clientParaData;
    const afterConfirm = queryData?.orderAfterConfirmDetails;
    const product = order?.productList?.[0];

    const updatedPayment = {
      company: afterConfirm?.tenantName || "",
      lineOfBusiness: subs?.subscriptionId || product?.productId || "",
      matterNumber: "",
      clientInfo: null,
      amount: order?.totalCost?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) || null,
      totalDiscount: subs?.totalDiscount?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || null,
      paymentMethod: queryData?.PaymentType || afterConfirm?.paymentType || "",
      paymentDate:(todayLocal() || null),
      description: product?.productType || "",
      components: [],
      businessName: afterConfirm?.subtenantName || "",
      checkNumber: "",
      payAmount: order?.paidAmt?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) || null,
      installmentFrequencies: "-1",
      installmentDate: "",
      installmentNumber: subs?.totalInstallment,
      subscriptionName: subs?.subscriptionName || product?.productName || afterConfirm?.order?.productList?.[0]?.productName || "",
      responsibleAttorney: subs?.attorneyId || afterConfirm?.responsibleAttorneyId || afterConfirm?.responsibleAttorney || "",
      originatingAttorney: subs?.originatingAttorneyId || afterConfirm?.originatingAttorneyId || afterConfirm?.originatingAttorney || "",
      checkDate: "",
      serviceMatNo: afterConfirm?.order?.matNo || "",
    };

    const updatedUser = {
      fullName: `${afterConfirm?.firstName || ""} ${afterConfirm?.lastName || ""}`.trim(),
      primaryEmail: afterConfirm?.primaryEmail || afterConfirm?.userEmail || "",
      primaryMobile: afterConfirm?.primaryContact || "",
      memberId: client?.memberId || afterConfirm?.userId || queryData?.UserId || "",
      matNo: afterConfirm?.order?.matNo || "",
      userId: afterConfirm?.userId || "",
      loginUserId: afterConfirm?.userId || "",
    };
    setPaymentData((prev) => {if (JSON.stringify(prev) === JSON.stringify(updatedPayment)) return prev; return updatedPayment});
    setSelectedUserData((prev) => {if (JSON.stringify(prev) === JSON.stringify(updatedUser)) return prev; return updatedUser});
    setPaymentaccount([{ AccountTypeId: 1, Amount: order?.totalCost?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2, })}]);
  }, [queryData]);

  useEffect(() => {
    if(isValidFuntion(userDeatils)){
      const queryParams = new URLSearchParams(window.location.search);
      const isPayLatter = JSON.parse(sessionStorage.getItem('isPayLatter'));
      const trxnStatus = queryParams.get('TrxnStatus');
      const orderId = queryParams.get('OrderId');
      setTrxnStatus(trxnStatus)

      // Preserve the original subtenantId for Federal Way Plaza
      const originalSubtenantId = sessionStorage.getItem('SubtenantId');
      const isFederalWayPlaza = originalSubtenantId == '989' || originalSubtenantId == '760';

      // Save LPL subtenant once from login data
      const loginSubId = String(userDeatils?.subtinentId);
      if (!sessionStorage.getItem('lplSubtenantId') && (loginSubId == '2' || loginSubId == '742')) {
        sessionStorage.setItem('lplSubtenantId', loginSubId);
      }

      if(trxnStatus == "SUCCESS"){
        // Don't change subtenantId for Federal Way Plaza
        if (!isFederalWayPlaza) {
          sessionStorage.setItem('SubtenantId',userDeatils?.subtinentId)
        }
        afterPaymentFlow(isFederalWayPlaza ? originalSubtenantId : userDeatils?.subtinentId, userDeatils?.userId, orderId, '')
      }else if(trxnStatus == 'CANCELLED' && isPayLatter !== true){
        // Don't change subtenantId for Federal Way Plaza
        if (!isFederalWayPlaza) {
          sessionStorage.setItem('SubtenantId',userDeatils?.subtinentId)
        }
        afterPaymentFlow(isFederalWayPlaza ? originalSubtenantId : userDeatils?.subtinentId, userDeatils?.userId, orderId, trxnStatus)
      }
      else if(trxnStatus == 'FAILED'){
        // Don't change subtenantId for Federal Way Plaza
        if (!isFederalWayPlaza) {
          sessionStorage.setItem('SubtenantId',userDeatils?.subtinentId)
        }
        afterPaymentFlow(isFederalWayPlaza ? originalSubtenantId : userDeatils?.subtinentId, userDeatils?.userId, orderId, trxnStatus)
      }
      // if(trxnStatus == 'FAILED'){
      //   sessionStorage.removeItem('userDeatils');
      //   return;
      // }
      // if(!orderId){
      //   sessionStorage.removeItem('userDeatils');
      // }
    }
    let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
    setIsSplitpaymentsession(issplitPayment)
  }, [])

    useEffect(() => {
    if (useLoader) {
      document.body.style.overflow = 'hidden'; // disable scroll
    } else {
      document.body.style.overflow = 'auto'; // enable scroll
    }
  }, [useLoader]);

  useEffect(()=>{
    resetToLifepaointdata()
    setSelectedUserData({
            fullName: '',
            primaryEmail: '',
            primaryMobile: '',
            memberId: '',
            matNo:''
          })
  },[timeMatter])

  const afterPaymentFlow = async (subtinentId, id,orderId,trxnStatus,datas) => {
    setuseLoader(true)
    const stateObj = JSON.parse(sessionStorage.getItem('userDeatils')) || {};
    let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;

    const {userAuthSubId,userId,viaCard} = stateObj
    if(trxnStatus == 'FAILED'){
      sessionStorage.removeItem('advancePaymentPending');
      sessionStorage.removeItem('advanceRecurringResult');
      sessionStorage.removeItem('recursionData');
      setuseLoader(false)
      setToast({ message: 'Payment failed. Please try again or contact the administrator.', type: 'error' });
      return;
    }

    const result = await get_UserData(subtinentId, id);

    // Don't remove SubtenantId for Federal Way Plaza - this causes folder errors
    // if(sessionStorage.getItem('SubtenantId') == 989 || subtinentId == federal_way_plazaId){
    // setuseLoader(false)
    // resetToCompanySelection()
    // sessionStorage.removeItem('SubtenantId');
    // sessionStorage.removeItem('userDeatils');
    // }
    if(trxnStatus == 'CANCELLED'){
      sessionStorage.removeItem('advancePaymentPending');
      sessionStorage.removeItem('advanceRecurringResult');
      setuseLoader(false)
    if(viaCard == true){
      setTimeout(()=>{
      if(issplitPayment == true && trxnStatus != 'FAILED'){
      setToast({ message: 'Redirecting to Payment Screen. Please wait.', type: "success" });
      setTimeout(()=>{
                   if(queryData?.paymnetFromIntake != 'true'){

      setOpenRecipetModal(false)
      setInvoiceHtml('');
              }
      setSelectedCompany('life_point_law')
      setIsUpdated(true)
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
      const split = user?.splitCards;
      const cards = isJSON(split) ? JSON.parse(split) : [];
      setSplitcards(cards || [{id:1,amount:0}]);
      // Only set split payment to Yes if there are more cards to process
      if (cards?.length > 0 && user?.splitCardnumber && cards?.length > user.splitCardnumber) {
        setSplitPaymentno('Yes')
      }
      setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      setRecurringCardAMA(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMA)
      setInstallmentpay((JSON.parse(sessionStorage.getItem('userDeatils'))?.isInstallmentPayment ? 1 : null))
      setPaymentoption(2)
      },4000)
      }
      },1000)
      return;
    }
    // code for all flows
      setTimeout(()=>{
      let queryData = JSON?.parse(sessionStorage.getItem('queryData'))
      if(queryData && queryData?.paymnetFromIntake != 'true'){
      setOpenRecipetModal(false)
      setInvoiceHtml('');
      }
      setSelectedCompany('life_point_law')
      setIsUpdated(true)
      if(issplitPayment == true){
      setSplitcards(JSON?.parse(JSON?.parse(sessionStorage?.getItem('userDeatils'))?.splitCards))
      setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      setRecurringCardAMA(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMA)
      setRecurringCardAMAfee(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMAfee)
      }
      // Only set split payment to Yes if we're continuing with split payment flow
      const userDetails = JSON.parse(sessionStorage.getItem('userDeatils'));
      if (userDetails && userDetails.splitPayment && issplitPayment == true) {
        setSplitPaymentno('Yes')
      }
      },1500)

      if(viaCard == true){
      setTimeout(()=>{
      if(issplitPayment == true && trxnStatus != 'FAILED'){
      if(trxnStatus == 'CANCELLED'){
        resetToCompanySelection('')
        sessionStorage.removeItem('userDeatils');
        sessionStorage.removeItem('userRegistred');
        sessionStorage.removeItem('SessPrimaryUserId');
        sessionStorage.removeItem('isAdvancePayment');
        setIsSplitpaymentsession(false)
        navigate('/')
        return;
      }
      setToast({ message: 'Redirecting to Payment Screen. Please wait.', type: "success" });
      setTimeout(()=>{
      if(queryData?.paymnetFromIntake != 'true'){
      setOpenRecipetModal(false)
      setInvoiceHtml('');
      }
      setIsUpdated(true)
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
      const split = user?.splitCards;
      const cards = isJSON(split) ? JSON.parse(split) : [];
      setSplitcards(cards || [{id:1,amount:0}]);
      // Only set split payment to Yes if there are more cards to process
      if (cards?.length > 0 && user?.splitCardnumber && cards?.length > user.splitCardnumber) {
        setSplitPaymentno('Yes')
      }
      setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      setRecurringCardAMA(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMA)
      setRecurringCardAMAfee(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMAfee)
      setInstallmentpay((JSON.parse(sessionStorage.getItem('userDeatils'))?.isInstallmentPayment ? 1 : null))
      setPaymentoption(2)
      },4000)
      }
      },1000)
      }

      return;
    }

    if(trxnStatus !== 'CANCELLED'){
      const result_data = await get_PaymentRecipet(orderId,id);
      if(result_data?.receiptHTML != null){
         const cleanedHtml = result_data?.receiptHTML
            .replace(/<html[^>]*>/gi, '')
            .replace(/<\/html>/gi, '')
            .replace(/<head[^>]*>.*?<\/head>/gis, '')
            .replace(/<body[^>]*>/gi, '')
            .replace(/<\/body>/gi, '');
        // if(issplitPayment != true){
            setInvoiceHtml(cleanedHtml);
            setOpenRecipetModal(true)
            // After payment success & receipt (Client Service Billing) modal opens:
            // first add the AMA subscription from the form fields, then fetch it
            // (subscriptionId 1). Guarded + non-blocking.
            // In this card/online flow paymentData state can be stale, so pass the
            // attorney/amount values from the session userDeatils (stateObj) as overrides.
            if (isValidFuntion(id)) {
              await runAmaReceiptChain({
                subtenantId: subtinentId,
                userID: id,
                orderId: orderId,
                overrides: {
                  responsibleAttorney: stateObj?.responsibleAttorney,
                  originatingAttorney: stateObj?.originatingAttorney,
                  // Service type (lineOfBusiness). AMA = 1 -> subscriptionId "1", else null.
                  // stateObj?.lineOfBusiness is now saved in sessionStorage (userDeatils)
                  // so it survives the PaymentGateway redirect. paymentData state may be
                  // stale after the redirect, so stateObj is the primary source.
                  lineOfBusiness: stateObj?.lineOfBusiness ?? paymentData?.lineOfBusiness,
                  // Amount can be empty on userDeatils in the card flow, so fall back
                  // to the order details (same source used to build the confirm order).
                  payAmount: stateObj?.payAmount ?? queryData?.clientOrderDetails?.paidAmt ?? queryData?.clientOrderDetails?.totalCost,
                  amount: stateObj?.amount ?? queryData?.clientOrderDetails?.totalCost ?? queryData?.clientOrderDetails?.paidAmt,
                },
              });
            }
        // }
      }

       if(result?.length > 0  && subtinentId !== federal_way_plazaId){
         const user = result[0];
         setSelectedUserData((prev) => ({
           ...prev,
           userId: user?.userId || result_data?.userId || '',
           fullName: user?.clientName || `${result_data?.firstName || ''} ${result_data?.lastName || ''}`.trim(),
           primaryEmail: user?.clientEmail || result_data?.primaryEmail || '',
           primaryMobile: user?.clientPhone || result_data?.primaryContact || '',
           memberId: user?.userId || result_data?.userId || '',
           loginUserId: user?.userId || result_data?.userId || ''
         }));
       }else{
        if(result_data == 'err' || result_data?.length == 0 || result_data == null) return
        const {firstName,lastName,userId} = result_data
        setSelectedUserData((prev) => ({
           ...prev,
           userId: userId,
           fullName: firstName+" "+lastName ,
           primaryEmail: '',
           primaryMobile: '',
           memberId: userId,
           loginUserId: userId
         }))
       }
    }
    const data = isValidFuntion(result[0]?.userAuthSubs) && result[0]?.userAuthSubs?.filter((ele) => ele?.userAuthSubId == userDeatils?.userAuthSubId)
    if (data?.length > 0) {
      const { userId, userAuthSubId, orderId } = userDeatils
      const { subscriptionName, subscriptionId, paymentType, totalAmount,originatingAttorney,responsibleAttorney,authUnit,authLength } = data[0]
      const json = {
        "serviceName": subscriptionName,
        "lineOfBusiness": subscriptionId,
        "paymentMethod": paymentType,
        "amount": totalAmount,
        "responsibleAttorney" :responsibleAttorney,
        "originatingAttorney" :originatingAttorney,
        'subscriptionName':subscriptionName,
        'notes':stateObj?.notes || null,
        'authUnit':authUnit,
        'authLength':authLength,
        'subscriptionName':subscriptionName,
        'totalDiscount':data[0]?.totalDiscount || 0,
        'sourceTypeId' : data[0]?.sourceTypeId || null
      }




      let authsubsJaon = generateSubscriptionJson("", json, orderId, userAuthSubId, userId,trxnStatus)
      authsubsJaon['installmentAmount'] = data[0]?.installmentAmount?.toFixed(2) || null
      let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))
      let queryDataForRouting = JSON.parse(sessionStorage.getItem('queryData') || 'null');
      if(viaCard == true && trxnStatus !== 'FAILED' && trxnStatus !== 'CANCELLED'){
      // issplitPayment
      if (queryDataForRouting?.subscriptionType === "advancePayment") {
        await cardPaymentAgreementfunc(data[0], stateObj, userId, authsubsJaon, issplitPayment, queryDataForRouting, true, orderId);
      } else if(issplitPayment == true){
          if(userDeatilsession?.splitCardnumber == userDeatilsession?.recurringCard){
          await cardPaymentfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment);
          setToast({message:`Installments are implemented on Card ${userDeatilsession?.splitCardnumber}.`,type:'success'})
          }
      }else{
        await cardPaymentfunc(data[0],stateObj,userId,authsubsJaon);
      }
      // issplitPayment without installmant
      setTimeout(()=>{

      if(issplitPayment == true && trxnStatus != 'FAILED'){

      if(trxnStatus == 'CANCELLED'){
        resetToCompanySelection('')
        sessionStorage.removeItem('userDeatils');
        sessionStorage.removeItem('userRegistred');
        sessionStorage.removeItem('SessPrimaryUserId');
        sessionStorage.removeItem('isAdvancePayment');
        setIsSplitpaymentsession(false)
        navigate('/')
        return;
      }
      setToast({ message: 'Redirecting to Payment Screen. Please wait.', type: "success" });
      setTimeout(()=>{
      if(queryData?.paymnetFromIntake != 'true'){
      setOpenRecipetModal(false)
      setInvoiceHtml('');
      }
      // setSelectedCompany('life_point_law')
      // setSplitcards()
      setIsUpdated(true)
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
      const split = user?.splitCards;
      const cards = isJSON(split) ? JSON.parse(split) : [];
      setSplitcards(cards || [{id:1,amount:0}]);
      // Only set split payment to Yes if there are more cards to process
      if (cards?.length > 0 && user?.splitCardnumber && cards?.length > user.splitCardnumber) {
        setSplitPaymentno('Yes')
      }
      setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      setRecurringCardAMA(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMA)
      setRecurringCardAMAfee(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMAfee)
      setInstallmentpay((JSON.parse(sessionStorage.getItem('userDeatils'))?.isInstallmentPayment ? 1 : null))
      // setInstallmentpay(1)
      setPaymentoption(2)
      // setPaymentData({...paymentData,originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney});
      },4000)
      }
      },1000)

      }
      let queryData = JSON?.parse(sessionStorage.getItem('queryData'))

    if(userDeatilsession?.splitCardnumber != userDeatilsession?.recurringCard && queryData?.paymnetFromIntake != 'true'){
      let recurringData = JSON.parse(sessionStorage.getItem('recursionData'))
      if(recurringData && issplitPayment == true){
        authsubsJaon["authSubscriptionId"] = recurringData?.authSubscriptionId
        // authsubsJaon["cutomerProfileId"] = recurringData?.authorizeCustomerProfileId
        // authsubsJaon["paymentProfileId"] =  recurringData?.authorizePaymentProfileId
        authsubsJaon['installmentAmount'] = recurringData?.installmentAmount
        authsubsJaon['installmentStartDate'] = recurringData?.installmentStartDate
        authsubsJaon['totalOccurrence'] = recurringData?.totalOccurrence
        authsubsJaon['authLength'] = recurringData?.authLength
      }
      const datas = Services?.upserUserAuthSubs(authsubsJaon)
      datas.then((res) => {
        setIsUpdated(true)
        if(trxnStatus == 'SUCCESS'){
          setToast({ message: msg, type: "success" });
          // Update splitCardnumber to track completed payments
          incrementSplitCardNumber();
        }
        // sessionStorage.removeItem('userDeatils');
        setuseLoader(false)
        // window.location.replace("http://localhost:3000");
      }).catch((err) => {
         setuseLoader(false)
      })
    }
    }
    // }


    //code for AMA split

    if(issplitPayment == true && trxnStatus != 'FAILED'){
      if(trxnStatus == 'CANCELLED'){
        resetToCompanySelection('')
        sessionStorage.removeItem('userDeatils');
        sessionStorage.removeItem('userRegistred');
        sessionStorage.removeItem('SessPrimaryUserId');
        sessionStorage.removeItem('isAdvancePayment');
        setIsSplitpaymentsession(false)
        navigate('/')
        return;
      }
      setToast({ message: 'Redirecting to Payment Screen. Please wait.', type: "success" });
      setTimeout(async()=>{
      let queryData = JSON?.parse(sessionStorage.getItem('queryData'))
      // setSelectedCompany('life_point_law') // camment for AMA flow
      setIsUpdated(true)
      const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
      const raw = sessionStorage.getItem("userDeatils");
      const user = isJSON(raw) ? JSON.parse(raw) : {};
      const split = user?.splitCards;
      const cards = isJSON(split) ? JSON.parse(split) : [];
      setSplitcards(cards || [{id:1,amount:0}]);
      if(queryData?.paymnetFromIntake == 'true' && cards?.length > user.splitCardnumber){
      setOpenRecipetModal(false)
      setInvoiceHtml('');
      }
      // if(queryData?.paymnetFromIntake == 'true' && cards?.length == user.splitCardnumber){
      // // setOpenRecipetModal(false)
      // // setInvoiceHtml('');
      // setuseLoader(true)
      // setTimeout(() => {
      //   alert('run');
      //   handleClose();
      // },1000);
      // setuseLoader(false)
      // }
      if(queryData?.paymnetFromIntake == 'true'){
        if(user.splitCardnumber == 1){
          sessionStorage.setItem('recurringOrderId',user.orderId)
          const userById = await getApiCall('GET', AoUrl.get_UserProfileDetailsByUserId+userId)
          const filteredCard = userById[0]?.cards?.filter((ele)=>ele?.isDefault == true)
          sessionStorage.setItem('paymentProfileId',filteredCard[0]?.paymentProfileId)
        }
        if(user.splitCardnumber == user.recurringCardAMAfee){
          // alert(`Installments are implemented on Card ${user.splitCardnumber} for AMA.`)
          // sessionStorage.setItem('recurringOrderId',user.orderId)
          const userById = await getApiCall('GET', AoUrl.get_UserProfileDetailsByUserId+userId)
          const filteredCard = userById[0]?.cards?.filter((ele)=>ele?.isDefault == true)
          sessionStorage.setItem('paymentProfileIdAMA',filteredCard[0]?.paymentProfileId)
        }
      }
      // setSplitcards(JSON?.parse(JSON?.parse(sessionStorage?.getItem('userDeatils'))?.splitCards))
      // Only set split payment to Yes if we're continuing with split payment flow
      const userDetails = JSON.parse(sessionStorage.getItem('userDeatils'));
      if (userDetails && userDetails.splitPayment && issplitPayment == true) {
        setSplitPaymentno('Yes')
      }
      setRecurringCard(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCard)
      setRecurringCardAMA(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMA)
      setRecurringCardAMAfee(JSON.parse(sessionStorage.getItem('userDeatils'))?.recurringCardAMAfee)
      setScheculeCard(sessionStorage.getItem('scheduleCard') || '')
      if(data?.length > 0){
      const { userId, userAuthSubId, orderId } = userDeatils
      const { subscriptionName, subscriptionId, paymentType, totalAmount,originatingAttorney,responsibleAttorney,authUnit,authLength } = data[0]
      const json = {
        "serviceName": subscriptionName,
        "lineOfBusiness": subscriptionId,
        "paymentMethod": paymentType,
        "amount": totalAmount,
        "responsibleAttorney" :responsibleAttorney,
        "originatingAttorney" :originatingAttorney,
        'subscriptionName':subscriptionName,
        'notes':stateObj?.notes || null,
        'authUnit':authUnit,
        'authLength':authLength,
        'subscriptionName':subscriptionName,
        'totalDiscount':data[0]?.totalDiscount || 0,
        'sourceTypeId' : data[0]?.sourceTypeId || null
      }
      let authsubsJaon = generateSubscriptionJson("", json, orderId, userAuthSubId, userId,trxnStatus)
      authsubsJaon['installmentAmount'] = data[0]?.installmentAmount?.toFixed(2) || null
      let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))

      if(issplitPayment == true){
      if(userDeatilsession?.splitCardnumber == userDeatilsession?.recurringCardAMA && queryData && queryData?.subscriptionType != "onlyAMA"){
      await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,false);
      // setToast({message:`Installments are implemented on Card ${userDeatilsession?.splitCardnumber}.`,type:'success'})
      }
      }

      if(queryData && queryData?.subscriptionType == "AMA&Fee" && queryData?.installmentAmountAMA != null && userDeatilsession?.splitCardnumber == userDeatilsession?.recurringCardAMAfee){
        await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,true);
      }
      // if(queryData && queryData?.subscriptionType == "AMA&Fee" && queryData && queryData?.subsDetails?.length > 0 && isNotValidNullUndefileInstallmentAmount(queryData?.subsDetails[0]?.installmentAmount)){
      //   await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,false);
      // }
      if(queryData && queryData?.subscriptionType == "onlyAMA"){
        if(issplitPayment == true){
          if(userDeatilsession?.splitCardnumber == userDeatilsession?.recurringCardAMA){
           await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,true);
          }
        }
      }
      // let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))
      if(userDeatilsession?.splitCardnumber != userDeatilsession?.recurringCardAMA){
      let recurringData = JSON.parse(sessionStorage.getItem('recursionData'))
      if(recurringData && issplitPayment == true){
      if((queryData?.subscriptionType == "AMA&Fee" && authsubsJaon?.subscriptionId == 2) || queryData?.subscriptionType != "AMA&Fee" ){
        authsubsJaon["authSubscriptionId"] = recurringData?.authSubscriptionId
        // authsubsJaon["cutomerProfileId"] = recurringData?.authorizeCustomerProfileId
        // authsubsJaon["paymentProfileId"] =  recurringData?.authorizePaymentProfileId
        authsubsJaon['installmentAmount'] = recurringData?.installmentAmount
        authsubsJaon['installmentStartDate'] = recurringData?.installmentStartDate
        authsubsJaon['totalOccurrence'] = recurringData?.totalOccurrence
        authsubsJaon['authLength'] = recurringData?.authLength
        authsubsJaon['authUnit'] = recurringData?.authUnit
      }
      }

      const datas = Services?.upserUserAuthSubs(authsubsJaon)
      datas.then((res) => {
        setIsUpdated(true)
        if(trxnStatus == 'SUCCESS'){
          setToast({ message: msg, type: "success" });
          // Update splitCardnumber to track completed payments
          incrementSplitCardNumber();
        }
        setuseLoader(false)
      }).catch((err) => {
         setuseLoader(false)
      })
      }
      }

      // setPaymentData({...paymentData,originatingAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.originatingAttorney,responsibleAttorney:JSON.parse(sessionStorage.getItem('userDeatils'))?.responsibleAttorney});
      },1500)

    }

    let queryDataobj = JSON?.parse(sessionStorage.getItem('queryData')) != null ? JSON?.parse(sessionStorage.getItem('queryData')) : queryData
    let PaymentMethod = sessionStorage.getItem('PaymentMethod')
    if(queryData?.paymnetFromIntake == 'true' && PaymentMethod == 'card' && issplitPayment == false && (data?.length == 0 || data?.length == undefined)){
      // alert('orderId0')
      let subsdetails = queryData?.subsDetails?.length > 0 ? queryData?.subsDetails[0] : null
      let authsubsJaon = {
        // "serviceName": paymentData?.subscriptionName,
        "lineOfBusiness": paymentData?.subscriptionId,
        // "paymentMethod": paymentData?.paymentMethod,
        "totalAmount": subsdetails != null ? subsdetails?.totalAmount : paymentAccount?.totalAmount,
        "responsibleAttorney" :paymentData?.responsibleAttorney,
        "originatingAttorney" :paymentData?.originatingAttorney,
        'subscriptionName':paymentData?.subscriptionName,
        'notes':paymentData?.notes || null,
        'authUnit':paymentData?.authUnit,
        'authLength':paymentData?.authLength,
        'subscriptionId':paymentData?.lineOfBusiness,
        'totalDiscount':paymentData?.totalDiscount || 0,
        'sourceTypeId' : paymentData?.sourceType || null,
        "authSubsInstallments": [{
            "authSubInstallmentId": 0,
            "isActive": true,
            "orderId": orderId,
            "payAmountDate": (todayLocal() || null),
        }],
        'userId':id,
        'upsertedBy':loggedUserId || id,
        'isActive':true,
        'isDelete':false,
        'authSubsStartDate':(todayLocal() || null),
        'serviceMatNo':paymentData?.serviceMatNo
      }
      if(queryDataobj && queryDataobj?.subscriptionType == "AMA&Fee"){
        if(queryDataobj?.installmentAmountAMA != null){
        await cardPaymentAgreementfunc([],stateObj,id,authsubsJaon,issplitPayment,queryDataobj,true,orderId);
        }
        if(queryDataobj && queryDataobj?.subsDetails?.length > 0 && isNotValidNullUndefileInstallmentAmount(queryDataobj?.subsDetails[0]?.installmentAmount)){
        await cardPaymentAgreementfunc([],stateObj,id,authsubsJaon,issplitPayment,queryDataobj,false,orderId);
        }
      }
      if(queryDataobj && queryDataobj?.subscriptionType == "onlyAMA"){
        await cardPaymentAgreementfunc([],stateObj,id,authsubsJaon,issplitPayment,queryDataobj,true,orderId);
      }
      if (queryDataobj && queryDataobj?.subscriptionType == "advancePayment") {
        await cardPaymentAgreementfunc([], stateObj, id, authsubsJaon, issplitPayment, queryDataobj, true, orderId);
      }
      if(queryDataobj && queryDataobj?.subscriptionType != "AMA&Fee" && queryDataobj?.subscriptionType != "onlyAMA" && queryDataobj?.subscriptionType != "advancePayment" ){
        // alert(2)
        await cardPaymentAgreementfunc([],stateObj,id,authsubsJaon,issplitPayment,queryDataobj,false,orderId);
      }
        // resetToCompanySelection();
      }

    PaymentMethod = sessionStorage.getItem('PaymentMethod')

    if(PaymentMethod == 'card' && issplitPayment != true){
      let queryData = JSON?.parse(sessionStorage.getItem('queryData'))
      if(data?.length > 0 && queryData?.paymnetFromIntake == 'true'){
      const { userId, userAuthSubId, orderId } = userDeatils
      const { subscriptionName, subscriptionId, paymentType, totalAmount,originatingAttorney,responsibleAttorney,authUnit,authLength } = data[0]
      const json = {
        "serviceName": subscriptionName,
        "lineOfBusiness": subscriptionId,
        "paymentMethod": paymentType,
        "amount": totalAmount,
        "responsibleAttorney" :responsibleAttorney,
        "originatingAttorney" :originatingAttorney,
        'subscriptionName':subscriptionName,
        'notes':stateObj?.notes || null,
        'authUnit':authUnit,
        'authLength':authLength,
        'subscriptionName':subscriptionName,
        'totalDiscount':data[0]?.totalDiscount || 0,
        'sourceTypeId' : data[0]?.sourceTypeId || null
      }
      let authsubsJaon = generateSubscriptionJson("", json, orderId, userAuthSubId, userId,trxnStatus)
      authsubsJaon['installmentAmount'] = data[0]?.installmentAmount?.toFixed(2) || null
      let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))

      if(queryData && queryData?.subscriptionType == "AMA&Fee"){
        if(queryData?.installmentAmountAMA != null){
        await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,true);
        }


        if(queryData && queryData?.subsDetails?.length > 0 && isNotValidNullUndefileInstallmentAmount(queryData?.subsDetails[0]?.installmentAmount)){
          await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,false);
        }
        // delete authsubsJaon.authSubsInstallments
        // delete authsubsJaon.userAuthSubsTypes
        // delete authsubsJaon.authSubsEndDate
        // delete authsubsJaon.userAuthSubId
        // delete authsubsJaon.paymentType
        // const datas = Services?.upserUserAuthSubs(authsubsJaon)
        // datas.then((res) => {
        // setuseLoader(false)
        // }).catch((err) => {
        // setuseLoader(false)
        // })
      }
      if(queryData && queryData?.subscriptionType == "onlyAMA"){
          await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,true);
      }
      if(queryData && queryData?.subscriptionType != "AMA&Fee" && queryData?.subscriptionType != "onlyAMA" && queryData?.subscriptionType != "advancePayment"){
          await cardPaymentAgreementfunc(data[0],stateObj,userId,authsubsJaon,issplitPayment,queryData,false);
      }
      }
    }

    if(PaymentMethod == 'cash' && queryDataobj?.paymnetFromIntake == 'true' && queryDataobj?.subscriptionType == "AMA&Fee"){
        if(queryDataobj && queryDataobj?.subsDetails?.length > 0 && isNotValidNullUndefileInstallmentAmount(queryDataobj?.installmentAmountAMA)){
          // alert(1)
        let queryDataSubdetails = queryDataobj?.subsDetails[0]
        const json = {
        "serviceName": "Annual Maintenance Agreement",
        "lineOfBusiness": 1,
        "paymentMethod": PaymentMethod,
        "amount":queryDataobj?.installmentAmountAMA ,
        "responsibleAttorney" :queryDataSubdetails?.responsibleAttorney,
        "originatingAttorney" :queryDataSubdetails?.originatingAttorney,
        'subscriptionName':"Annual Maintenance Agreement",
        'notes':stateObj?.notes || null,
        'authUnit':'days',
        'authLength':365,
        'totalDiscount':0,
        'userId':userId,
        'upsertedBy':loggedUserId || userId,
      }

      let authsubsJaon = generateSubscriptionJson("", json, orderId, userAuthSubId, userId,trxnStatus)
      authsubsJaon['installmentAmount'] = queryDataobj?.installmentAmountAMA || null
      authsubsJaon['authSubsInstallments'] = [{}]
      authsubsJaon['authLength'] = '365'
      authsubsJaon['installmentStartDate'] = addOneYearToToday()
      authsubsJaon['totalOccurrence'] = 9999
      delete authsubsJaon.authSubsInstallments
      delete authsubsJaon.userAuthSubsTypes
      delete authsubsJaon.authSubsEndDate
      delete authsubsJaon.userAuthSubId
      // delete authsubsJaon.paymentType
      delete authsubsJaon.UserSubscriptionId
      let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))
        const datas = Services?.upserUserAuthSubs(authsubsJaon)
        datas.then((res) => {
        setuseLoader(false)
        }).catch((err) => {
        setuseLoader(false)
        })
        }
    }

    // else{
    //   // for single flow
    //   setTimeout(()=>{
    //   setOpenRecipetModal(false)
    //   setInvoiceHtml('');
    //   // setSelectedCompany('life_point_law')
    //   // setIsUpdated(true)
    //   },1000)
    // }
    // if(trxnStatus == 'FAILED' || trxnStatus == 'CANCELLED'){
    //   setSplitPaymentno('No')
    //   setIsSplitpaymentsession(false)
    // }
  };

  // useEffect(()=>{
  //   let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
  //   if(issplitPayment == true){
  //     setTimeout(()=>{
  //             setOpenRecipetModal(false)

  //     setInvoiceHtml('');
  //     setSelectedCompany('life_point_law')
  //     setIsUpdated(true)
  //     },500)
  //   }
  // },[])


  const cardPaymentfunc = async (data,stateObj,userId,authsubsJaon,issplitPayment) => {
              const userById = await getApiCall('GET', AoUrl.get_UserProfileDetailsByUserId+userId)
              const filteredCard = userById[0]?.cards?.filter((ele)=>ele?.isDefault == true)
              if(filteredCard?.length > 0){
                const jsonPost = {
                  "userLoginId": stateObj?.loginUserId || '76280',
                  "userId": userId,
                  "subscriptionName": data?.subscriptionName,
                  "paySchedule": { "length": data?.installmentFrequencies == 4 ? 7 : data?.installmentFrequencies || data?.authLength || null, "unit": data?.authUnit || "days","startDate":data?.installmentStartDate || null},
                  "totalOccurrences": data?.totalOccurrence || null, "amount": data?.installmentAmount?.toFixed(2) || null,
                  "customerProfileId": userById[0]?.customerProfileId,
                  "paymentProfileId": filteredCard[0]?.paymentProfileId,
                  "cardNumber": filteredCard[0]?.cardNumber, "expirationDate": filteredCard[0]?.expireDate,
                  "IsAuthSubsAdded" : true,
                  "authSubsStartDate": data?.authSubsStartDate || null,
                  "authSubsEndDate": data?.authSubsEndDate,
                  "paymentType": 1,
                  "notes": data?.notes || null,
                  "totalAmount" : data?.totalAmount,
                  "totalDiscount":data?.totalDiscount || 0,
                  "authLength":data?.authLength || null,
              }
              const _resultOfCreateSubs = await recurringErrorHandled(jsonPost); //Recurring
              const recursionData = _resultOfCreateSubs?.data?.data[0]

        if(recursionData != undefined){
        const {authorizeSubscriptionId,authorizeCustomerProfileId,authorizePaymentProfileId} = recursionData
              authsubsJaon["authSubscriptionId"] = authorizeSubscriptionId
              authsubsJaon["cutomerProfileId"] = authorizeCustomerProfileId
              authsubsJaon["paymentProfileId"] =  authorizePaymentProfileId
              authsubsJaon['installmentAmount'] = data?.installmentAmount?.toFixed(2) || null
              authsubsJaon['installmentStartDate'] = data.installmentStartDate || new Date()
              authsubsJaon['totalOccurrence'] = data.totalOccurrence || null
              authsubsJaon['authLength'] = data.authLength
              if(issplitPayment == true){
              sessionStorage.setItem('recursionData',JSON.stringify(authsubsJaon));
              }
        const datas = Services?.upserUserAuthSubs(authsubsJaon)
            datas.then((res) => {
            if(issplitPayment != true){
            setToast({ message: msg, type: "success" });
            }
            // sessionStorage.removeItem('userDeatils');
            setuseLoader(false)
            // window.location.replace("http://localhost:3000");
            }).catch((err) => {
            setuseLoader(false)
            })
        }else{
          // setToast({ message: 'Recurring Failed.', type: "error" });
        }
      }
  }

function addOneYearToToday() {
  const today = new Date();
  const newDate = new Date(today);
  newDate.setFullYear(today.getFullYear() + 1);
  return newDate;
}


  const cardPaymentAgreementfunc = async (data,stateObj,userId,authsubsJaon,issplitPayment,queryData,isAMArecurring,orderId) => {
              let authsubsJson = JSON.parse(JSON.stringify(authsubsJaon))
              const userById = await getApiCall('GET', AoUrl.get_UserProfileDetailsByUserId+userId)
              const filteredCard = userById[0]?.cards?.filter((ele)=>ele?.isDefault == true)
              let queryDataSubdetails = queryData?.subsDetails?.length > 0 ? queryData?.subsDetails[0] : null
              if (queryData?.subscriptionType === "advancePayment" && filteredCard?.length > 0) {
                const inFlightKey = `advancePaymentDone_${orderId || queryData?.OrderId || queryData?.orderID}`;
                if (sessionStorage.getItem(inFlightKey) === 'true') {
                  return;
                }
                let orderDetailsParsed = {};
                try { orderDetailsParsed = JSON.parse(queryData?.OrderDetails || "{}"); } catch (e) { }
                const advanceAmount = orderDetailsParsed?.SubscriptionAmt;
                const validFromDate = orderDetailsParsed?.ValidFromDate || todayLocal();
                const existingAuthorizeSubId = queryDataSubdetails?.authorizeSubscriptionId || queryDataSubdetails?.futureAuthorizeSubscriptionId;
                if (existingAuthorizeSubId) {
                  try {
                    const cancelUrl = `${AoUrl.postuserSubscriptionCancel}?userId=${userId}&authorizeSubscriptionId=${existingAuthorizeSubId}`;
                    await Services.postApiCallNew('POST', cancelUrl, {
                      cancellationTypeId: 3,
                      cancellationRemarks: JSON.stringify({ type: 'other', remark: 'Superseded by advance payment recurring subscription' }),
                      cancellationDetails: "",
                      CancelledBy: userId,
                    });
                  } catch (e) {
                    console.error('Failed to cancel existing recurring subscription before advance payment recurring create', e);
                  }
                }
                const jsonAdvance = {
                  userLoginId: 0,
                  userId,
                  subscriptionName: "Annual Maintenance Agreement",
                  paySchedule: { length: "365", unit: "days", startDate: validFromDate },
                  totalOccurrences: 9999,
                  amount: advanceAmount,
                  customerProfileId: userById[0]?.customerProfileId,
                  paymentProfileId: filteredCard[0]?.paymentProfileId,
                  cardNumber: filteredCard[0]?.cardNumber,
                  expirationDate: filteredCard[0]?.expireDate,
                  userSubscriptionId: queryDataSubdetails?.userSubscriptionId || authsubsJson?.UserSubscriptionId || 0,
                  subscriptionId: 1,
                  totalAmount: advanceAmount,
                  totalDiscount: 0,
                  orderId: orderId || queryData?.OrderId || queryData?.orderID || null,
                  isAuthSubsAdded: true,
                  isOneTimePay: false,
                };

                const _resultOfCreateSubs = await recurringErrorHandled(jsonAdvance);
                const recursionData = _resultOfCreateSubs?.data?.data?.[0];
                if (recursionData) {
                  sessionStorage.setItem(inFlightKey, 'true');
                  authsubsJson.authSubscriptionId = recursionData.authorizeSubscriptionId;
                  authsubsJson.cutomerProfileId = recursionData.authorizeCustomerProfileId;
                  authsubsJson.paymentProfileId = recursionData.authorizePaymentProfileId;
                  authsubsJson.installmentAmount = advanceAmount;
                  authsubsJson.installmentStartDate = validFromDate;
                  authsubsJson.totalOccurrence = 9999;
                  authsubsJson.authLength = "365";
                  authsubsJson.authUnit = "days";
                  authsubsJson.subscriptionId = 1;
                  authsubsJson.subscriptionName = "Annual Maintenance Agreement";
                  authsubsJson.totalAmount = advanceAmount;
                  if (issplitPayment == true || orderId != null) {
                    sessionStorage.setItem('recursionData', JSON.stringify(authsubsJson));
                  }

                  sessionStorage.setItem('advanceRecurringResult', JSON.stringify({
                    authorizeSubscriptionId: recursionData.authorizeSubscriptionId,
                    authorizeCustomerProfileId: recursionData.authorizeCustomerProfileId,
                    authorizePaymentProfileId: recursionData.authorizePaymentProfileId,
                  }));

                  const datas = Services?.upserUserAuthSubs(authsubsJson);
                  datas.then((res) => {
                    if (issplitPayment != true) {
                      setToast({ message: msg, type: "success" });
                    }
                    setuseLoader(false);
                  }).catch((err) => {
                    setuseLoader(false);
                  });
                }
                return;
              }
              const futurePayDate = new Date(queryDataSubdetails?.futurePayDate);
              const validityFrom = new Date(queryDataSubdetails?.validityFrom);
              const futurePayDateUTC = new Date(Date.UTC(futurePayDate.getFullYear(), futurePayDate.getMonth(), futurePayDate.getDate()));
              const validityFromUTC = new Date(Date.UTC(validityFrom.getFullYear(), validityFrom.getMonth(), validityFrom.getDate()));
              let installmentAmount = queryData?.subsDetails?.length > 0 && queryData?.subsDetails[0].isInstallmentPlan == true && isNotValidNullUndefileInstallmentAmount(queryData?.subsDetails[0].installmentAmount) ? queryData?.subsDetails[0].installmentAmount : data?.installmentAmount?.toFixed(2)
              const unit= queryDataSubdetails != null ? ((queryDataSubdetails?.installmentTypeId == 3 || queryDataSubdetails?.installmentTypeId == 4) ? "months" : "days") : data?.authUnit
              const lengthInstallment =queryDataSubdetails != null ? (queryDataSubdetails?.installmentTypeId == 3 ? 1 : queryDataSubdetails?.installmentTypeId == 4 ? 12 : queryDataSubdetails?.installmentTypeId == 2 ? 7 : Math.round((futurePayDateUTC - validityFromUTC) / (1000 * 60 * 60 * 24))) : (data?.installmentFrequencies == 4 ? 7 : data?.installmentFrequencies || data?.authLength)
              const totalOccurrences = queryDataSubdetails != null ? queryDataSubdetails?.totalInstallment : data?.totalOccurrence
              const startDate = queryDataSubdetails != null ? queryDataSubdetails?.futurePayDate : data?.installmentStartDate
              const isOnetimePay = queryDataSubdetails != null ? queryDataSubdetails?.isInstallmentPlan != true && isNotValidNullUndefileInstallmentAmount(queryDataSubdetails?.installmentAmount) ? true : false : false
              if(filteredCard?.length > 0){
                const jsonPost = {
                  "userLoginId": 0 || '76280',
                  "userId": userId,
                  "subscriptionName": data?.subscriptionName || paymentData?.subscriptionName,
                  "paySchedule": { "length": lengthInstallment || null, "unit":isOnetimePay == true ? 'days' : (unit || "days"),"startDate": isOnetimePay == true ? null : startDate},
                  "totalOccurrences": totalOccurrences || null, "amount": isOnetimePay == true ? queryDataSubdetails?.installmentAmount : (installmentAmount || null),
                  "customerProfileId": userById[0]?.customerProfileId,
                  "paymentProfileId": filteredCard[0]?.paymentProfileId,
                  "cardNumber": filteredCard[0]?.cardNumber, "expirationDate": filteredCard[0]?.expireDate,
                  "IsAuthSubsAdded" : true,
                  // "authSubsStartDate": data?.authSubsStartDate || null,
                  // "authSubsEndDate": data?.authSubsEndDate,
                  // "paymentType": 1,
                  "notes": data?.notes || null,
                  "totalAmount" :orderId ? queryDataSubdetails?.totalAmount : (data?.totalAmount || paymentData?.amount),
                  "totalDiscount":data?.totalDiscount || 0,
                  // "authLength":data?.authLength || null,
                  "orderId":orderId || queryData?.orderID || queryData?.OrderId || null,
                  "userSubscriptionId":queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0,
                  "responsibleAttorney":queryDataSubdetails?.attorneyId,
                  "originatingAttorney":queryDataSubdetails?.originatingAttorneyId,
                  "subscriptionId": data?.subscriptionId || paymentData?.lineOfBusiness,
                  "isOneTimePay": isOnetimePay == true ? true : false,

              }

              const missedRenewalsParsed = queryDataSubdetails?.missedRenewals
                ? (typeof queryDataSubdetails.missedRenewals === 'string' ? JSON.parse(queryDataSubdetails.missedRenewals) : queryDataSubdetails.missedRenewals)
                : null;
              const recurringAmountFromMissed = missedRenewalsParsed && isNotValidNullUndefileInstallmentAmount(missedRenewalsParsed?.recurringamount)
                ? Number(missedRenewalsParsed.recurringamount)
                : null;
              let amaAmount = recurringAmountFromMissed != null ? recurringAmountFromMissed : (queryData?.subscriptionType == "AMA&Fee" && queryData?.installmentAmountAMA != null ? queryData?.installmentAmountAMA : isNotValidNullUndefileInstallmentAmount(queryData?.installmentRenew) ? queryData?.installmentRenew : (queryData?.clientOrderDetails?.productList?.[0]?.totalProductPrice || paymentData?.amount))
              const jsonAMA = {
                "originatingAttorney":queryDataSubdetails?.originatingAttorneyId,
                "responsibleAttorney":queryDataSubdetails?.attorneyId,
                "userLoginId":0,//check this id
                "userId":userId,
                "subscriptionName":"Annual Maintenance Agreement",
                "paySchedule":{"length":"365","unit":"days","startDate":queryData && queryData?.subscriptionType == "AMA&Fee" ? addOneYearToToday() : null},
                "totalOccurrences":9999,"amount":amaAmount,
                "customerProfileId":userById[0]?.customerProfileId,
                "paymentProfileId":filteredCard[0]?.paymentProfileId,
                "cardNumber":filteredCard[0]?.cardNumber,
                "expirationDate":filteredCard[0]?.expireDate,
                "userSubscriptionId": queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0 ,
                "subscriptionId":queryData && queryData?.subscriptionType == 'AMA&Fee' ? 1 : queryDataSubdetails != null ? queryDataSubdetails?.subscriptionId : 0,
                "totalAmount":amaAmount,
                "totalDiscount":0,
                "orderId":queryData && queryData?.subscriptionType == "AMA&Fee" ? null : (queryData?.OrderId || queryData?.orderID || null),
                "isAuthSubsAdded":true,
                "isOneTimePay": false,
              }

              const _resultOfCreateSubs = await recurringErrorHandled((queryData?.subscriptionType == "onlyAMA" || (queryData?.subscriptionType == "AMA&Fee" && queryData?.installmentAmountAMA)) && isAMArecurring == true ? jsonAMA :jsonPost); //Recurring
              const recursionData = _resultOfCreateSubs?.data?.data[0]

        if(recursionData != undefined){
        const {authorizeSubscriptionId,authorizeCustomerProfileId,authorizePaymentProfileId} = recursionData
              authsubsJson["authSubscriptionId"] = authorizeSubscriptionId
              authsubsJson["cutomerProfileId"] = authorizeCustomerProfileId
              authsubsJson["paymentProfileId"] =  authorizePaymentProfileId
              authsubsJson['installmentAmount'] = isOnetimePay == true ? queryDataSubdetails?.installmentAmount : isAMArecurring == true  ? amaAmount : installmentAmount || null
              authsubsJson['installmentStartDate'] = isOnetimePay == true ? queryDataSubdetails?.futurePayDate : isAMArecurring == true ? addOneYearToToday() : data.installmentStartDate || new Date()
              authsubsJson['totalOccurrence'] = isAMArecurring == true ? 9999 : (data.totalOccurrence || queryDataSubdetails?.totalInstallment || null)
              authsubsJson['authLength'] = isAMArecurring == true ? '365' : data.authLength
              // authsubsJaon['userId'] = userId
              if(isAMArecurring == true){
                // authsubsJaon['userSubscriptionId'] = queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0
                authsubsJson = {...authsubsJson,'userSubscriptionId':(queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0),authUnit:'days',subscriptionId:1,subscriptionName:'Annual Maintenance Agreement',totalDiscount:0,UpsertedBy:loggedUserId || userId,userId:userId}
                if(queryData?.subscriptionType == "AMA&Fee"){
                    delete authsubsJson.authSubsInstallments
                    delete authsubsJson.userAuthSubsTypes
                    delete authsubsJson.authSubsEndDate
                    delete authsubsJson.userAuthSubId
                    delete authsubsJson.paymentType
                    delete authsubsJson.UserSubscriptionId
                    // delete authsubsJaon.authSubscriptionId
                    // delete authsubsJaon.cutomerProfileId
                    // delete authsubsJson.sourceTypeId
                    authsubsJson = {...authsubsJson,totalAmount:amaAmount,subtenantId:2,installmentAmount:amaAmount,installmentStartDate:addOneYearToToday()}
                }
              }
              if(queryData?.subscriptionType == "onlyFee" || queryData?.subscriptionType == "onlyProbate"){
                delete authsubsJson.userAuthSubsTypes
                // delete authsubsJson.sourceTypeId
                delete authsubsJson.paymentType
                delete authsubsJson.authSubsEndDate
                authsubsJson = {...authsubsJson,'userSubscriptionId':(queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0),authLength:lengthInstallment,installmentStartDate:queryDataSubdetails!=null ? queryDataSubdetails?.futurePayDate : data.installmentStartDate,authUnit:unit}
              }
              if(queryData?.subscriptionType == "onlyProbate"){
                authsubsJson = {...authsubsJson,'subtenantId':(queryDataSubdetails != null ? queryDataSubdetails?.subtenantId : 2)}
              }
              if(queryData?.subscriptionType == "AMA&Fee" && isAMArecurring != true){
                    // delete authsubsJaon.authSubsInstallments
                    delete authsubsJson.userAuthSubsTypes
                    delete authsubsJson.authSubsEndDate
                    // delete authsubsJaon.userAuthSubId
                    delete authsubsJson.paymentType
                    delete authsubsJson.UserSubscriptionId
                    authsubsJson = {...authsubsJson,'userSubscriptionId':(queryDataSubdetails != null ? queryDataSubdetails?.userSubscriptionId : 0),authLength:lengthInstallment,installmentStartDate:queryDataSubdetails!=null ? queryDataSubdetails?.futurePayDate : data.installmentStartDate,authUnit:unit}
                }
              if((issplitPayment == true || orderId != null) && isAMArecurring != true){
              sessionStorage.setItem('recursionData',JSON.stringify(authsubsJson));
              }
              if((issplitPayment == true || orderId != null) && queryData?.subscriptionType == "onlyAMA"){
                sessionStorage.setItem('recursionData',JSON.stringify(authsubsJson));
              }
            const datas = Services?.upserUserAuthSubs(authsubsJson)
            datas.then(async(res) => {
            if(issplitPayment != true){
            setToast({ message: msg, type: "success" });
            }
            if(paymentData?.sourceType == '999999' && data?.length == 0){
              await otherSourceref?.current?.saveHandleOther(res?.data?.data[0]?.userAuthSubId)
            }

            // sessionStorage.removeItem('userDeatils');
            setuseLoader(false)
            // window.location.replace("http://localhost:3000");
            }).catch((err) => {
            setuseLoader(false)
            })
        // try {
        //   setuseLoader(true);
        // const datas = await Services?.upserUserAuthSubs(authsubsJaon);
        // if (issplitPayment !== true) {
        //     setToast({ message: msg, type: "success" });
        //   }
        // } catch (err) {
        //   // handle error if needed
        // } finally {
        //   setuseLoader(false);
        // }

        }else{
          // setToast({ message: 'Recurring Failed.', type: "error" });
        }
      }
  }

  const get_UserData = (subtinentId,id) => {
    return new Promise((resolve, reject) => {
      Services?.getUserAuthSubs(subtinentId, id).then((res) => {
        if (res?.data) {
          resolve(res.data?.data);
        }
      })
        .catch((error) => {
          resolve('rr');
        });
    });
  };

  const get_PaymentRecipet = (orderId,id) => {
    return new Promise((resolve, reject) => {
      Services?.getGetOrderInfoApi(orderId,id).then((res) => {
        if (res?.data) {
          resolve(res.data?.data);
        }
      })
        .catch((error) => {
          resolve('rr');
        });
    });
  };

   function formatToUS(value) {
    if (!value) return "";
    // let cleaned = value?.replace(/,/g, "");
    let cleaned = String(value).replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(cleaned)) {
      return null;
    }

    const parts = cleaned?.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] !== undefined ? parts[1] : null;

    integerPart = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (decimalPart === null) {
      return integerPart;
    } else {
      return integerPart + "." + decimalPart;
    }
  }


  // Sample client database for Life Point Law
  const clientDatabase = {
    'LP2025001': {
      clientName: 'John Smith',
      originatingAttorney: 'rajiv_nagaich',
      responsibleAttorney: 'rajiv_nagaich',
      services: ['estate', 'probate']
    },
    'LP2025002': {
      clientName: 'Maria Garcia',
      originatingAttorney: 'nana_mensah',
      responsibleAttorney: 'nana_mensah',
      services: ['immigration']
    },
    'LP2025003': {
      clientName: 'Robert Johnson',
      originatingAttorney: 'michael_dickson',
      responsibleAttorney: 'aaron_paker',
      services: ['crisis', 'estate']
    }
  };
  // Company configurations
  const companies = {
    life_point_law: {
      name: 'Life Point Law',
      color: 'bg-blue-600',
      linesOfBusiness: [
        'non_crisis',
        'estate',
        'crisis',
        'probate',
        'trust',
        'immigration',
        'real_estate',
        'ama',
        'other'
      ]
    },

    aging_options: {
      name: 'Aging Options',
      color: 'bg-green-600',
      linesOfBusiness: [
        'products',
        'workshops',
        'guided_planning',
        'radio_sponsorships',
        'pbs_commissions'
      ]
    },
    federal_way_plaza: {
      name: 'Federal Way Professional Plaza',
      color: 'bg-purple-600',
      linesOfBusiness: [
        'rent_collection',
        'parking_fees',
        'late_fees',
        'security_deposits',
        'utilities',
        'maintenance_fees',
        'other'
      ]
    }
  };
  const attorneys = [
    { id: 'rajiv_nagaich', name: 'Rajiv Nagaich' },
    { id: 'michael_dickson', name: 'Michael Dickson' },
    { id: 'aaron_paker', name: 'Aaron Paker' },
    { id: 'nana_mensah', name: 'Nana Mensah' }
  ];
  // Handle company selection
  const handleCompanySelect = (companyId) => {
    setSelectedCompany(companyId);

    // Store company details in sessionStorage for persistence
    let subtenantId, subtenantName;

    // Save the LPL subtenant once — only if not already saved and current session is LPL (2 or 742)
    const currentSession = sessionStorage.getItem('SubtenantId');
    if (!sessionStorage.getItem('lplSubtenantId') && (currentSession == '2' || currentSession == '742')) {
      sessionStorage.setItem('lplSubtenantId', currentSession);
    }

    switch (companyId) {
      case 'life_point_law':
        subtenantId = sessionStorage.getItem('lplSubtenantId');
        subtenantName = 'Life Point Law';
        break;
      case 'aging_options':
        subtenantId = '3';
        subtenantName = 'Aging Options';
        break;
      case 'federal_way_plaza':
        subtenantId = federal_way_plazaId; // 989 or 760
        subtenantName = 'Federal Way Professional Plaza';
        break;
      case 'time_matters':
        subtenantId = time_mattersSubtinent; // 988
        subtenantName = 'Time Matters';
        break;
      default:
        subtenantId = null;
        subtenantName = null;
    }

    // Store in sessionStorage and sync cookie
    if (subtenantId && subtenantName) {
      sessionStorage.setItem('companyName', companyId);
      sessionStorage.setItem('SubtenantId', subtenantId);
      sessionStorage.setItem('subtenantName', subtenantName);
      // Clear old cookie first, then set new value
      document.cookie = `subtenantId=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
      document.cookie = `subtenantId=${subtenantId};path=/`;
      console.log('[Cookie] subtenantId set to:', subtenantId, '| verify:', document.cookie);
    }

    setPaymentData({
      ...paymentData,
      company: companyId,
      lineOfBusiness: '',
      matterNumber: '',
      clientInfo: null
    });
  };

  // Handle matter number lookup for Life Point Law
  const handleMatterNumberChange = (matterNumber) => {
    const clientInfo = clientDatabase[matterNumber];
    setPaymentData({
      ...paymentData,
      matterNumber,
      clientInfo
    });
  };
  // Handle form updates
  const handleInputChange = (field, value) => {
   if(field == 'amount'){
    value = value.toString()?.replace(/[^\d,\.]/g, '');
    const [intPart, ...rest] = value?.split('.');
    const decPart = rest.join('');          // drops any extra dots
    value = intPart + (decPart ? '.' + decPart : '');
    }
    setPaymentData({
      ...paymentData,
      [field]: value
    });
  };
  // Reset to company selection
  const resetToCompanySelection = async (userProfile) => {
    if (queryData?.paymnetFromIntake === "true" && userProfile) {
      const sessionPaymentMethod = sessionStorage.getItem("PaymentMethod");
      const subs = queryData?.subsDetails?.[0];
      const isFullyPaid = subs?.totalAmount === subs?.totalPaid + (!isNotValidNullUndefileInstallmentAmount(subs?.totalDiscount)  ? 0 : subs?.totalDiscount);
      if (isFullyPaid && sessionPaymentMethod === "card" && ["AMA&Fee"].includes(queryData?.subscriptionType)) {
        const resposeData = await userAuthSubs(selectedUserData, paymentData, 0, 0)
        if(paymentData?.sourceType == '999999'){
        await otherSourceref?.current?.saveHandleOther(resposeData?.data?.data[0]?.userAuthSubId)
        }
      }
      // if (sessionPaymentMethod === "card" && ["onlyProbate","onlyFee"].includes(queryData?.subscriptionType)) {
      //   userAuthSubs(selectedUserData, paymentData, 0, 0)
      // }
      handleClose("noNeedToRun");
      return;
    }
    if(config?.isLogin == false){
      setSelectedCompany('');
    }
    setPaymentData({
      company: '',
      lineOfBusiness: '',
      matterNumber: '',
      clientInfo: null,
      amount: 0,
      paymentMethod: '',
      // paymentDate: new Date().toISOString().split('T')[0],
      paymentDate:(todayLocal() || null),
      description: '',
      components: {},
      payAmount:null,
      installmentFrequencies:'-1',
      installmentDate:'',
      installmentNumber:'',
      totalDiscount: null,
    });
    setShowaddcard(false)
    setOrderIdData('')
    setInstallmentpay('')
    setPaymentaccount([])
    setRecurringCard('')
    setSplitcards([{id:1,amount:0}])
    setSplitPaymentno('No') //disable payment button
    sessionStorage.removeItem('userDeatils')
    setAddnewservice(false)
  };

  const resetToLifepaointdata = () => {
    // setSelectedCompany('');
    setPaymentData({
      company: '',
      lineOfBusiness: '',
      matterNumber: '',
      clientInfo: null,
      amount: 0,
      paymentMethod: '',
      // paymentDate: new Date().toISOString().split('T')[0],
      paymentDate:(todayLocal() || null),
      description: '',
      components: [],
      payAmount:null,
      installmentFrequencies:1,
      installmentDate:'',
      installmentNumber:'',
      notes:'',
      authUnit:'months',
      totalDiscount: null,
    });
    setShowaddcard(false)
    setOrderIdData('')
    setInstallmentpay('')
    setInstallmentamount(0)
    setPaymentoption(1)
    setPaymentaccount([])
    setAddnewservice(false)
    // setRecurringCard('')
    // setSplitcards([{id:1,amount:0}]);
  };

  function normalizeAmount(value) {
  // Handle null, undefined, empty string, or invalid input
  if (value == null || value === "" || value === "--" || value === "-") return 0;

  // If it's already a valid number, return as-is
  if (typeof value === "number" && !isNaN(value)) return value;

  if (typeof value === "string") {
    // Remove currency symbols, spaces, and non-numeric characters except . , and -
    let cleaned = value.replace(/[^\d.,-]/g, "").trim();

    // If European-style (e.g. "1.234,56"), convert to "1234.56"
    if (cleaned.match(/,\d{2}$/) && cleaned.includes(".")) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    }
    // Remove commas for standard Indian/US formats ("10,000.00")
    else {
      cleaned = cleaned.replace(/,/g, "");
    }

    // Convert to float
    const num = parseFloat(cleaned);

    // Return a valid number or 0 if NaN
    return isNaN(num) ? 0 : num;
  }

  // For any other type (e.g., object, boolean)
  return 0;
}


  // Submit payment
  const handleSubmit = async (e) => {
    if (!isValidFuntion(selectedUserData?.memberId) && queryData?.paymnetFromIntake !== "true") {
      setToast({ message: "Before submitting, please save the user’s details.", type:"error" });
      return
    }
    if (parseFloat(String(paymentData?.payAmount)?.replace(/,/g, "")) > parseFloat(String(paymentData?.amount)?.replace(/,/g, ""))) {
      setToast({ message: "Please enter the valid initial amount.", type:"error" });
      return
    }
    if(splitPaymentno == 'Yes' && PaymentOption == 2){
      if(paymentData?.payAmount == undefined || paymentData.payAmount == '' || paymentData?.payAmount == null || parseFloat(String(paymentData?.payAmount)?.replace(/,/g, "")) < parseFloat(String(paymentData?.splitAmount)?.replace(/,/g, ""))){
        setToast({ message: "Please enter the valid initial amount.", type:"error" });
        return
      }
    }
        if(payLatter !== true){
        sessionStorage.removeItem('isPayLatter');
       }
       if(paymentAccount?.length == 0 && splitPaymentno != 'Yes' && PaymentOption == 1 && selectedCompany =="life_point_law"){
        setToast({ message: "Please select the account type.", type:"error" });
        return
       }
      if(paymentAccount?.length == 0 && splitPaymentno != 'Yes' && (PaymentOption == 2 && paymentData?.payAmount !== null && paymentData?.payAmount !== undefined && paymentData?.payAmount !== '' && !isNaN(Number(paymentData?.payAmount)))){
        setToast({ message: "Please select the account type.", type:"error" });
        return
       }
      //  return
       if((validatePaymentData() == false) || (isNullUndefine(validatePaymentData()))){
         return
       }

      if(paymentAccount?.length > 0){
        let installmentpaylater = isNotValidNullUndefile(paymentData.userAuthSubId) ? true : false
        let tAmount = (installmentpay != '') ? paymentData?.payAmount : paymentData?.amount;
        let accountSum = paymentAccount?.reduce((a, c) => {
          const cleanAmt = Number(c.Amount?.toString().replace(/,/g, '')) || 0;
          return a + cleanAmt;
        }, 0);
        const numPay = Number(paymentData?.payAmount?.toString().replace(/,/g, '')) || 0;
        const numTAmount = Number(tAmount?.toString().replace(/,/g, '')) || 0;
        const numAccountSum = Number(accountSum?.toString().replace(/,/g, '')) || 0;
        if (installmentpaylater ? numPay.toFixed(2) != numAccountSum.toFixed(2) : numTAmount.toFixed(2) != numAccountSum.toFixed(2)) {
          setToast({ message: 'Please enter a valid amount.', type: "error" });
          return;
        }
        accountSum = formatToUS(accountSum.toString());
      }

    if (installmentpay !== '' && PaymentOption == 2) {

      let keys = Object.keys(paymentData);

      // Remove 'payAmount' if installmentpay == 2
      if (installmentpay == 2) {
        keys = keys?.filter((k) => k !== "payAmount");
      }

      for (let i = 0; i < keys?.length; i++) {
        const key = keys[i];

        // Only validate keys present in keyNameObj
        if (!keyNameObj.hasOwnProperty(key)) continue;

        const value = paymentData[key];
        if (value === '' || value === undefined || value === null || value === 0 || value == '-1') {
          setToast({
            message: `Please enter ${keyNameObj[key]}.`,
            type: "error",
          });
          return;
        }
      }
    }


    if(paymentData.paymentMethod == ''){
      setToast({message:'Please select the Payment Type.',type:"error"})
      return;
    }
    if(installmentpay == 2 && (paymentData?.paymentMethod != "cash" && paymentData?.paymentMethod != "check" && paymentData?.paymentMethod != 'ACH')){
      setOrderIdData(true)
      return;
    }

    if((paymentData.paymentMethod == 'cash' || paymentData?.paymentMethod == "check" || paymentData?.paymentMethod == 'ACH') && PaymentOption == 2 && installmentpay == 2){
      // Cash/Check/ACH installment ("Process Installment"):
      //  1. AddUserOrder    -> get orderId
      //  2. ConfirmUserOrder
      //  3. AMA subscription chain (add/update -> details -> upsert -> get -> plans),
      //     passing orderId and futurePayDate = null.
      //  4. userAuthSubs
      const cashInstallmentSubtenantId = queryData?.paymnetFromIntake === "true" ? queryData?.subtenantId : selectedCompany === 'aging_options' ? 3 : selectedCompany == "time_matters" ? time_mattersSubtinent : selectedCompany == 'federal_way_plaza' ? federal_way_plazaId : lplSubtinent;
      // Step 1: create the order (reuse existing addOrderUser; returns the order object
      // with memberId (int), userId (GUID) and orderId).
      const _order = await addOrderUser(selectedUserData, paymentData);
      const cashOrderId = _order && _order !== 'err' ? _order?.orderId : null;
      const cashOrderMemberId = _order && _order !== 'err' ? _order?.memberId : null; // integer
      const cashOrderUserId = _order && _order !== 'err' ? _order?.userId : null;     // GUID
      // Step 2: confirm the order (paymentType: cash=2, check=4, ACH=6).
      // Signature: confirmOrder(userId, memberId, orderId, loggedUserId, paymentType, receiptHtml)
      if (cashOrderId) {
        const cashPaymentType = paymentData?.paymentMethod == "check" ? 4 : paymentData?.paymentMethod == 'ACH' ? 6 : 2;
        await confirmOrder(cashOrderUserId, cashOrderMemberId, cashOrderId, loggedUserId, cashPaymentType, '');
      }
      // Step 3: AMA subscription chain with orderId + null futurePayDate.
      await runAmaSubscriptionChain({
        Services,
        subtenantId: cashInstallmentSubtenantId ?? sessionStorage.getItem('SubtenantId'),
        userId: selectedUserData?.memberId,
        orderId: cashOrderId,
        amount: paymentData?.amount, // total amount (for SKU match)
        payAmount: paymentData?.payAmount ?? paymentData?.amount,
        responsibleAttorney: paymentData?.responsibleAttorney,
        originatingAttorney: paymentData?.originatingAttorney,
        lineOfBusiness: paymentData?.lineOfBusiness,
        loggedUserId: sessionStorage.getItem('loggedUserId'),
        paymentDate: paymentData?.paymentDate,
        // Installment fields -> validityFrom = installment date, totalAmount/totalPaid = total.
        installmentDate: paymentData?.installmentDate,
        installmentAmount: paymentData?.installmentAmount ?? installmentAmount,
        installmentFrequencies: paymentData?.installmentFrequencies,
        // Cash/Check/ACH installment: futurePayDate must be null.
        futurePayDateNull: true,
      });
      // Step 4: create the auth subscription with the new orderId.
      userAuthSubs(selectedUserData, paymentData, cashOrderId || 0, 0)
      setToast({ message: msg, type:"success" });
      setTimeout(()=>{
      // setSelectedCompany('')
      resetToCompanySelection()
      },1000)
      return;
    }

    let selectPaymenttype = '';
    let recurringcardData = '';
    let recurringcardDataAMA = '';
    let recurringcardDataAMAfee = '';
    const isAdvancePaymentFlow = sessionStorage.getItem('isAdvancePayment') === 'true';
    if (installmentpay == 1 && PaymentOption == 2) {   // CHANGED: removed "|| isAdvancePaymentFlow"
      const method = paymentData?.paymentMethod?.toLowerCase();
      let label = "Cash";
      if (method === "check") label = "Check";
      else if (method === "ach") label = "ACH";
      else if (method === "credit" || method === "card") label = "Cash";
      if (typeof confirm === "function") {
        if (splitPaymentno == 'Yes') {
        // Get current card number being processed
        const currentCardNumber = (paymentData?.splitCardnumber || 0) + 1;

        if(recurringCard == ''){
          // Show modal only for Card 1, auto-select for Card 2 and beyond
          if(currentCardNumber === 1) {
            let checkCardforReccuring = await confirm(
            true,
            "Would you like to proceed with scheduling your installment using Card 1? If not, kindly choose an alternative card.",
            "Premission",
            "custom",
            [
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]
          );
          if(checkCardforReccuring == true){
            setRecurringCard(1)
            recurringcardData = 1;
            const updated = splitCards?.map((c, i) =>i == 1 ? { ...c, installmentcard:true } : c);
            setSplitcards(updated);
          }
          } else {
            // Auto-select for Card 2 and beyond
            setRecurringCard(currentCardNumber)
            recurringcardData = currentCardNumber;
            const updated = splitCards?.map((c, i) =>i == currentCardNumber ? { ...c, installmentcard:true } : c);
            setSplitcards(updated);
          }
        // Continue with payment processing regardless of installment choice
      }

        selectPaymenttype = true
        }else{
        selectPaymenttype = await confirm(
          installmentpay == 1 ? true : false,
          "Do you want to schedule your installment via?",
          "Premission",
          "custom",
          [
            { label: label, value: false },
            { label: "Card", value: true },
          ]
        );
            }
      }
    }

    // Show confirm prompt even when coming from Intake
    let orderDetailsParsed = {};
    if (typeof queryData?.OrderDetails === "string") {
      orderDetailsParsed = JSON.parse(queryData?.OrderDetails);
    }
    const subscriptionAmt = Number(orderDetailsParsed?.SubscriptionAmt || 0);
    const subs = queryData?.subsDetails?.[0];
    let paymentMethodFromSession = sessionStorage.getItem("PaymentMethod");
    if (scheduleCard != true && scheduleCard != 'true' && paymentMethodFromSession != 'cash') {
      if (((((queryData?.paymnetFromIntake === "true" && scheduleCard == '') && (["onlyAMA"].includes(queryData?.subscriptionType) || (["AMA&Fee"].includes(queryData?.subscriptionType) && subscriptionAmt > 0)) && !((queryData?.subscriptionType === "onlyFee" && queryData?.clientOrderDetails?.totalCost !== queryData?.clientOrderDetails?.paidAmt) || (["onlyFee", "onlyProbate","onlyAMA"].includes(queryData?.subscriptionType) && queryData?.totalInstallment > 0) || (queryData?.subscriptionType === "AMA&Fee" && subscriptionAmt > 0 && queryData?.subsDetails[0]?.installmentAmount === 0 && subscriptionAmt > 0 && queryData?.clientOrderDetails?.totalCost === queryData?.clientOrderDetails?.paidAmt)) && !selectPaymenttype) || (["onlyFee", "onlyProbate",'onlyAMA'].includes(queryData?.subscriptionType) && (queryData?.totalInstallment > 0 || queryData?.subsDetails?.[0]?.totalInstallment > 0))) || queryData?.paymnetFromIntake === "true" && subscriptionAmt > 0 && ["AMA&Fee"].includes(queryData?.subscriptionType)) || ["AMA&Fee"].includes(queryData?.subscriptionType) && subs?.totalAmount !== subs?.totalPaid && subs?.subscriptionId === 2 || isAdvancePaymentFlow) {
      const method = paymentData?.paymentMethod?.toLowerCase();
      let secondOptionLabel = "Cash";
      if (method === "check") secondOptionLabel = "Check";
      else if (method === "ach") secondOptionLabel = "ACH";
      else if (method === "cash") secondOptionLabel = "Cash";
      else if (["credit", "card"].includes(method)) secondOptionLabel = "Cash";

      selectPaymenttype = await confirm(
        true,
        "Do you want to schedule your installment via?",
        "Premission",
        "custom",
        [
          { label: secondOptionLabel, value: false },
          { label: "Card", value: true },
        ]
      );
      let finalMethod = method;

      if (selectPaymenttype) {
        finalMethod = "card";
      } else {
        finalMethod = secondOptionLabel.toLowerCase();
      }
      setFinalIntallmentMethod(finalMethod)
      sessionStorage.setItem("PaymentMethod", finalMethod)
      if(queryData?.paymnetFromIntake == 'true' && scheduleCard == ''){
      setScheculeCard(selectPaymenttype)
      sessionStorage.setItem("scheduleCard", selectPaymenttype)
      if(selectPaymenttype && paymentData?.paymentMethod == 'credit' && splitPaymentno == 'Yes'){
        return;
      }
      }
    }
    }else{
      if(paymentMethodFromSession == 'card'){
      selectPaymenttype = 'card'
      setFinalIntallmentMethod('card')
      sessionStorage.setItem("PaymentMethod", 'card')
      }
    }
    let sessionPaymentMethod = sessionStorage.getItem('PaymentMethod')
    if(splitPaymentno == 'Yes' && selectPaymenttype == 'card' && queryData?.paymnetFromIntake == 'true' && sessionPaymentMethod == 'card'){
        // Get current card number being processed
        const currentCardNumber = (paymentData?.splitCardnumber || 0) + 1;

        if(recurringCardAMA == '' &&  !(["AMA&Fee","onlyFee","onlyProbate","onlyAMA"].includes(queryData?.subscriptionType) && queryData?.subsDetails?.length > 0 && (queryData?.subsDetails[0].isInstallmentPlan == false || queryData?.subsDetails[0].isInstallmentPlan == null) && !isNotValidNullUndefileInstallmentAmount(queryData?.subsDetails[0].installmentAmount))){

          // Show modal only for Card 1, auto-select for Card 2 and beyond
          if(currentCardNumber === 1) {
            let checkCardforReccuring = await confirm(
            true,
            "Would you like to proceed with scheduling your installment using Card 1? If not, kindly choose an alternative card.",
            "Premission",
            "custom",
            [
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]
          );
          if(checkCardforReccuring == true){
            setRecurringCardAMA(1)
            recurringcardDataAMA = 1;
            const updated = splitCards?.map((c, i) =>i == 1 ? { ...c, installmentcard:true } : c);
            setSplitcards(updated);
          }
          } else {
            // Auto-select for Card 2 and beyond
            setRecurringCardAMA(currentCardNumber)
            recurringcardDataAMA = currentCardNumber;
            const updated = splitCards?.map((c, i) =>i == currentCardNumber ? { ...c, installmentcard:true } : c);
            setSplitcards(updated);
          }
        // Continue with payment processing regardless of installment choice
      }
      if(recurringCardAMAfee == '' && ["AMA&Fee"].includes(queryData?.subscriptionType) && queryData?.installmentAmountAMA){

          // Show modal only for Card 1, auto-select for Card 2 and beyond
          if(currentCardNumber === 1) {
            let checkCardforReccuring = await confirm(
            true,
            "Would you like to proceed with scheduling your AMA installment using Card 1? If not, kindly choose an alternative card.",
            "Premission",
            "custom",
            [
              { label: 'Yes', value: true },
              { label: 'No', value: false },
            ]
          );
          if(checkCardforReccuring == true){
            setRecurringCardAMAfee(1)
            recurringcardDataAMAfee = 1;
            // const updated = splitCards?.map((c, i) =>i == 1 ? { ...c, installmentcard:true } : c);
            // setSplitcards(updated);
          }
          } else {
            // Auto-select for Card 2 and beyond
            setRecurringCardAMAfee(currentCardNumber)
            recurringcardDataAMAfee = currentCardNumber;
          }
        // Continue with payment processing regardless of installment choice
      }


        // selectPaymenttype = true
        }
    setuseLoader(true)

let _reasult;
let memberId, userId, orderId;

if (isAdvancePaymentFlow) {
  const issplitPaymentOrderId = sessionStorage.getItem('userDeatils')
    ? JSON.parse(sessionStorage.getItem('userDeatils'))?.orderId
    : null;
  const existingOrderId =
    issplitPaymentOrderId ||
    sessionStorage.getItem('orderId') ||
    queryData?.OrderId ||
    queryData?.orderId ||
    queryData?.orderID ||
    null;

  if (existingOrderId) {
    orderId = existingOrderId;
    sessionStorage.setItem('orderId', existingOrderId);

    const orderInfo = await Services?.getGetOrderInfoApi(existingOrderId, selectedUserData?.memberId);
    const orderInfoData = orderInfo?.data?.data;
    memberId = orderInfoData?.order?.memberId ?? orderInfoData?.userId ?? selectedUserData?.memberId;
    userId = orderInfoData?.order?.userId ?? orderInfoData?.userId ?? memberId;

    _reasult = orderInfoData?.order ? orderInfoData.order : { orderId, memberId, userId };
  } else {
    _reasult = await addOrderUser(selectedUserData, paymentData);
    ({ memberId, orderId, userId } = _reasult || {});
  }
} else {
  _reasult = await addOrderUser(selectedUserData, paymentData);
  ({ memberId, orderId, userId } = _reasult || {});
}

    if (paymentData?.paymentMethod == "cash" || paymentData?.paymentMethod == "check" || paymentData?.paymentMethod == 'ACH') {
      const generalAcc = paymentAccount?.find(a => a.AccountTypeId === 1);
      const ioltaAcc = paymentAccount?.find(a => a.AccountTypeId === 2);
      const generalAmount = parseFloat(String(generalAcc?.Amount || "0").replace(/,/g, ""));
      const ioltaAmount = parseFloat(String(ioltaAcc?.Amount || "0").replace(/,/g, ""));
      let amountPay = installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId) ? paymentData?.payAmount : paymentData?.amount || 0;
      const hasGeneral = generalAmount > 0;
      const hasIOLTA = ioltaAmount > 0;
      const noSplitFound = !hasGeneral && !hasIOLTA;
      const isCheck = paymentData?.paymentMethod === "check";
      const isACH = paymentData?.paymentMethod === "ACH";
      const accountName = isACH ? (paymentData?.accountName || "") : "";
      const accountNumber = isACH ? (paymentData?.accountNumber || "") : "";
      const routingNumber = isACH ? (paymentData?.routingNumber || "") : "";
      const bankName = (isACH || isCheck) ? (paymentData?.bankName || "") : "";
      const checkNumber = isCheck ? (paymentData?.checkNumber || "") : "";
      const checkDate = isCheck
        ? (paymentData?.checkDate ? formatDateToMMDDYY(paymentData?.checkDate) : "")
        : "";
      let updatedreceiptCashpaymentGeneral = receiptCashpaymentGeneral
        .replace('@@PRODUCTNAME', paymentData?.lineOfBusiness == '9' ? paymentData?.subscriptionName : paymentData?.serviceName || "")
        .replace('@@ORDERID', orderId)
        .replace('@@PONUMBER', "")
        .replace('@@CUSTOMERID', "")
        .replace('@@INVOICENUMBER', "")
        .replace('@@CLIENTNAME', selectedUserData?.fullName)
        .replace('@@ADDRESSLINE1', "")
        .replace('@@CITYSTATEZIP', "")
        .replace('@@COUNTRY', "")
        .replace('@@CLIENTPHONE', formatPhoneNumber(selectedUserData?.primaryMobile))
        .replace('@@CLIENTEMAIL', selectedUserData?.primaryEmail)
        .replace("@@TOTALPAID", formatToUS((noSplitFound ? parseFloat(String(amountPay)?.replace(/,/g, "")) || 0 : generalAmount).toFixed(2)))
        // .replace('@@PAYMENTTIME', formatDateToMMDDYY(paymentData?.paymentDate) || formatDatePDT())
         .replace('@@PAYMENTTIME', formatDateToMMDDYY(paymentData?.paymentDate) || formatDatePDT())
        .replace('@@TRANSACTIONID', "")
        .replace('@@TRANSACTIONTYPE', "")
        .replace('@@TRANSACTIONSTATUS', "Successful")
        .replace('@@AUTHORIZATIONCODE', "")
        .replace('@@CARDNUMBER', capitalizeFirst(paymentData?.paymentMethod))
        .replace('@@CHECKNUMBER', checkNumber || '')
        .replace('@@CHECKDATE', checkDate || '')
        .replace('@@ACCOUNTNAME', accountName || '')
        .replace('@@ACCOUNTNUMBER', accountNumber || '')
        .replace('@@ROUTINGNUMBER', routingNumber || '')
        .replace('@@BANKNAME', bankName || '');

      let updatedreceiptCashpaymentIOLTA = receiptCashpaymentIOLTA
      updatedreceiptCashpaymentIOLTA = receiptCashpaymentIOLTA
        .replace('@@PRODUCTNAME', paymentData?.lineOfBusiness == '9' ? paymentData?.subscriptionName : paymentData?.serviceName || "")
        .replace('@@ORDERID', orderId)
        .replace('@@PONUMBER', "")
        .replace('@@CUSTOMERID', "")
        .replace('@@INVOICENUMBER', "")
        .replace('@@CLIENTNAME', selectedUserData?.fullName)
        .replace('@@ADDRESSLINE1', "")
        .replace('@@CITYSTATEZIP', "")
        .replace('@@COUNTRY', "")
        .replace('@@CLIENTPHONE', formatPhoneNumber(selectedUserData?.primaryMobile))
        .replace('@@CLIENTEMAIL', selectedUserData?.primaryEmail)
        .replace("@@TOTALPAID", formatToUS(isNaN(ioltaAmount) ? 0 : ioltaAmount.toFixed(2)))
        .replace('@@PAYMENTTIME', formatDateToMMDDYY(paymentData?.paymentDate) || formatDatePDT())
        .replace('@@TRANSACTIONID', "")
        .replace('@@TRANSACTIONTYPE', "")
        .replace('@@TRANSACTIONSTATUS', "Successful")
        .replace('@@AUTHORIZATIONCODE', "")
        .replace('@@CARDNUMBER', capitalizeFirst(paymentData?.paymentMethod))
        .replace('@@CHECKNUMBER', checkNumber || '')
        .replace('@@CHECKDATE', checkDate || '')
        .replace('@@ACCOUNTNAME', accountName || '')
        .replace('@@ACCOUNTNUMBER', accountNumber || '')
        .replace('@@ROUTINGNUMBER', routingNumber || '')
        .replace('@@BANKNAME', bankName || '');

      let updatedreceiptCashpayment = "";
      if (hasGeneral && hasIOLTA) {updatedreceiptCashpayment = `${updatedreceiptCashpaymentGeneral} <div style="height:45px;"></div> <div style="page-break-after: always;"></div> ${updatedreceiptCashpaymentIOLTA}`;
      } else if (hasGeneral && !hasIOLTA) {
        updatedreceiptCashpayment = updatedreceiptCashpaymentGeneral;
      } else if (!hasGeneral && hasIOLTA) {
        updatedreceiptCashpayment = updatedreceiptCashpaymentIOLTA;
      } else {
        updatedreceiptCashpayment = updatedreceiptCashpaymentGeneral;
      }
        // setSelectedCompany('')
        // setOpenRecipetModal(true)
        // setInvoiceHtml(updatedreceiptCashpayment)
      const _reasults = await confirmOrder(userId, memberId, orderId, loggedUserId, paymentData?.paymentMethod == "check" ? 4 : paymentData?.paymentMethod == 'ACH' ? 6 : 2,updatedreceiptCashpayment)
      setConfirmOrderDetails(_reasults)
      setuseLoader(false)
      if (_reasults !== 'err') {
        if(selectPaymenttype){
          setOrderIdData(_reasult)
          setShowaddcard(selectPaymenttype)
          // userAuthSubs(selectedUserData, paymentData, orderId, 0)
          return
        }else{
        upsertUserLegalStaff(paymentData)
        setToast({ message: msg, type:"success" });
        let paymentRecipet = await get_PaymentRecipet(orderId,selectedUserData?.memberId)
        setInvoiceHtml(paymentRecipet?.receiptHTML)
        // uploadFilefunc()
        setOpenRecipetModal(true)
        // After payment success & receipt (Client Service Billing) modal opens:
        // first add the AMA subscription from the form fields, then fetch it
        // (subscriptionId 1). Guarded + non-blocking.
        if (isValidFuntion(selectedUserData?.memberId)) {
          const receiptSubtenantId = queryData?.paymnetFromIntake === "true" ? queryData?.subtenantId : selectedCompany === 'aging_options' ? 3 : selectedCompany == "time_matters" ? time_mattersSubtinent : selectedCompany == 'federal_way_plaza' ? federal_way_plazaId : lplSubtinent;
          await runAmaReceiptChain({
            subtenantId: receiptSubtenantId,
            userID: selectedUserData?.memberId,
            orderId: orderId,
            overrides: {
              // Service type (lineOfBusiness). AMA = 1 -> subscriptionId "1", else null.
              lineOfBusiness: paymentData?.lineOfBusiness,
              // Fall back to order details if the live form amount is empty.
              payAmount: paymentData?.payAmount ?? queryData?.clientOrderDetails?.paidAmt ?? queryData?.clientOrderDetails?.totalCost,
              amount: paymentData?.amount ?? queryData?.clientOrderDetails?.totalCost ?? queryData?.clientOrderDetails?.paidAmt,
            },
          });
        }
        // generatePdf()
        const othSubs = await userAuthSubs(selectedUserData, paymentData, orderId, 0)
        if(paymentData?.sourceType == '999999'){
        await otherSourceref?.current?.saveHandleOther(othSubs?.data?.data[0]?.userAuthSubId)
        }

          setTimeout(()=>{
          //  setSelectedCompany('')
           resetToCompanySelection()
          },1000)
        }
      }
    } else {
      if (_reasult !== 'err') {
        setuseLoader(false)
        // Credit/Card payment (full + installment): run the AMA subscription chain
        // (add/update -> details -> upsert -> get -> plans) before userAuthSubs.
        // AMA-only (skips for other service types), non-blocking.
        // {
        //   const creditSubtenantId = queryData?.paymnetFromIntake === "true" ? queryData?.subtenantId : selectedCompany === 'aging_options' ? 3 : selectedCompany == "time_matters" ? time_mattersSubtinent : selectedCompany == 'federal_way_plaza' ? federal_way_plazaId : lplSubtinent;
        //   const isCreditInstallment = installmentpay == 1 && isValidFuntion(paymentData?.installmentDate);
        //   await runAmaSubscriptionChain({
        //     Services,
        //     subtenantId: creditSubtenantId ?? sessionStorage.getItem('SubtenantId'),
        //     userId: selectedUserData?.memberId,
        //     orderId: orderId,
        //     amount: paymentData?.amount, // total amount (for SKU match)
        //     payAmount: paymentData?.payAmount ?? paymentData?.amount,
        //     responsibleAttorney: paymentData?.responsibleAttorney,
        //     originatingAttorney: paymentData?.originatingAttorney,
        //     lineOfBusiness: paymentData?.lineOfBusiness,
        //     loggedUserId: sessionStorage.getItem('loggedUserId'),
        //     paymentDate: paymentData?.paymentDate,
        //     // Installment fields (only when this is an installment credit payment).
        //     installmentDate: isCreditInstallment ? paymentData?.installmentDate : undefined,
        //     installmentAmount: isCreditInstallment ? (paymentData?.installmentAmount ?? installmentAmount) : undefined,
        //     installmentFrequencies: isCreditInstallment ? paymentData?.installmentFrequencies : undefined,
        //   });
        // }
        const othSubs = await userAuthSubs(selectedUserData, paymentData, 0, 0)
        if (othSubs?.data?.data?.length > 0) {
          let sessionObj = {
            userEmail: selectedUserData?.primaryEmailAddress,
            userId: selectedUserData?.memberId,
            userAuthSubId: othSubs?.data?.data[0]?.userAuthSubId,
            orderId: orderId,
            subtinentId : queryData?.paymnetFromIntake === "true" ? queryData?.subtenantId :selectedCompany === 'aging_options' ? 3 : selectedCompany == "time_matters" ? time_mattersSubtinent : selectedCompany == 'federal_way_plaza' ? federal_way_plazaId : lplSubtinent,
            // viaCard: selectPaymenttype,
            loginUserId:selectedUserData?.loginUserId,
            notes:paymentData?.notes || null,
            serviceName:(paymentData?.lineOfBusiness == '9' || paymentData?.lineOfBusiness == '21') ? paymentData?.subscriptionName : paymentData?.serviceName || "",
            splitPayment: paymentData?.splitAmount ? true : false,
            splitCards: paymentData?.splitAmount ? JSON.stringify(splitCards) : [],
            splitCardnumber:paymentData?.splitCardnumber ? paymentData?.splitCardnumber+1 :1,
            originatingAttorney:paymentData?.originatingAttorney,
            responsibleAttorney:paymentData?.responsibleAttorney,
            recurringCard:recurringCard == '' ? recurringcardData : recurringCard,
            isInstallmentPayment: installmentpay == 1 ? true : false,
            // paymentAccount:paymentAccount,
            payAmount:paymentData?.payAmount,
            amount:paymentData?.amount,
            authLength: (paymentData?.installmentFrequencies == '-1' ? null : paymentData?.installmentFrequencies == 4 ? 7 : paymentData?.installmentFrequencies) || null,
            authUnit: paymentData?.authUnit || "days",
            installmentFrequencies:paymentData?.installmentFrequencies,
            installmentStartDate: paymentData?.installmentDate,
            installmentNumber:paymentData?.installmentNumber,
            recurringCardAMA:recurringCardAMA == '' ? recurringcardDataAMA : recurringCardAMA,
            scheduleCard:scheduleCard,
            recurringCardAMAfee:recurringCardAMAfee == '' ? recurringcardDataAMAfee : recurringCardAMAfee,
            lineOfBusiness: paymentData?.lineOfBusiness,
          }
          if(paymentData?.sourceType == '999999'){
          await otherSourceref?.current?.saveHandleOther(othSubs?.data?.data[0]?.userAuthSubId)
          }
          // return
          if(installmentpay == 1 || isAdvancePaymentFlow){
            sessionObj = {...sessionObj,viaCard: selectPaymenttype}
          }
          sessionStorage.setItem('userDeatils', JSON.stringify(sessionObj))
          // return;
          setOrderIdData(_reasult);
        }
      }
    }
  }

   const validatePaymentData = () => {
    if (isNullUndefine(paymentData.lineOfBusiness)) {
      setToast({
        message: `Please select the Service Type.`,
        type: "error",
      });
      setAddnewservice(true)
      scrollToSection()
      return ; // ⛔ STOP
    } else if (isNullUndefine(paymentData.amount) || paymentData.amount == 0) {
      setToast({ message: "Please enter the pay amount.", type: "error" });
      return; // ⛔ STOP
    } else if (isNullUndefine(paymentData.paymentMethod)) {
      setToast({ message: "Please select the payment method.", type: "error" });
      return; // ⛔ STOP
    }else{
      return true;
    }
  };

  ///////////////create json/////////////////////////
const generateOrderJson = (selectedUserData, formData) => {

  const sub = queryData?.subsDetails?.[0];
  let missed = sub?.missedRenewals ? JSON.parse(sub.missedRenewals) : null;
  // const today = new Date().toISOString().split("T")[0];
  // const validityFrom = sub?.validityFrom?.split("T")[0];
  const today = (todayLocal() || null);
  const validityFrom = sub?.validityFrom?.split("T")[0];
  const isLaterDueToday = missed && String(missed.number) === "0" && missed.paymentSchedule === "Later" && validityFrom === today;
  let portalFinalAmount = null;
  const subs = queryData?.subsDetails?.[0];
  if (queryData22) {
    const subs22 = queryData22?.subsDetails?.[0];
    const missed = subs?.missedRenewals ? JSON.parse(subs.missedRenewals) : null;
    if (missed && missed.paymentSchedule === "Now" && missed.amaTypes === "Portal") {
      const baseAmount = Number(missed.amount || 0);
      const count = Number(missed.number || 0);
      const portalAmount = subs22?.totalAmount
        ? Number(subs22.totalAmount)
        : 1500;
      portalFinalAmount = baseAmount * count + portalAmount;
    }
  }
  let splitAMAproductList = []
  if(queryData?.paymnetFromIntake === "true"){
  splitAMAproductList = [{
    ...queryData?.clientOrderDetails?.productList[0],
    "paidProductPrice":  paymentData?.splitAmount,
    "productPrice": paymentData?.splitAmount,
    "totalProductPrice": paymentData?.splitAmount,
    "quantity": paymentData?.splitAmount ? 1 : queryData?.clientOrderDetails?.productList[0]?.quantity,
    isActive: true
  }]
  if(queryData?.clientOrderDetails?.productList?.length > 1){
    splitAMAproductList.push(queryData?.clientOrderDetails?.productList[1])
  }
}
  let paymentAccountfilter = paymentAccount?.filter((e)=>{return e.Amount != 0})
  let issplitPaymentOrderId = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.orderId : false;

  // For Federal Way Plaza (subtinentId 989 or 760), use clientUserId (GUID) instead of memberId (integer)
  // Check multiple conditions to detect Federal Way Plaza
  const currentSubtenantId = sessionStorage.getItem('SubtenantId');
  const isFederalWayPlaza = formData?.company === 'federal_way_plaza' ||
                           selectedUserData?.tenantName ||
                           selectedUserData?.tenantId ||
                           selectedUserData?.clientUserId ||
                           currentSubtenantId == '989' ||
                           currentSubtenantId == '760';

  const userIdForOrder = queryData?.paymnetFromIntake === "true"
    ? queryData?.clientParaData?.memberId
    : (isFederalWayPlaza
        ? (selectedUserData?.clientUserId || selectedUserData?.loginUserId || selectedUserData?.memberId)
        : selectedUserData?.memberId);

  // For Federal Way Plaza, use clientUserId for createdBy as well
  const createdByForOrder = queryData?.paymnetFromIntake === "true"
    ? queryData?.clientParaData?.memberId
    : (isFederalWayPlaza
        ? (selectedUserData?.clientUserId || selectedUserData?.loginUserId || selectedUserData?.memberId)
        : selectedUserData?.memberId);

  const orderLoggedUserId = getLoggedUserId() || loggedUserId || null;

  // Debug logging for Federal Way Plaza
  if (isFederalWayPlaza) {
    console.log("Federal Way Plaza Payment Debug:", {
      currentSubtenantId,
      selectedUserData,
      userIdForOrder,
      createdByForOrder,
      formData
    });
  }

  return {
    userId: userIdForOrder,
    orderId:issplitPaymentOrderId ? issplitPaymentOrderId : 0,
    promoCode: "",
    shippingCost: 0,
    taxCost: 0,
    totalCost: isLaterDueToday ? subs?.totalAmount : portalFinalAmount !== null ? portalFinalAmount : isLaterDueToday ? queryData?.clientOrderDetails?.paidAmt : (paymentData?.splitAmount ? paymentData?.splitAmount : queryData?.paymnetFromIntake === "true" ? (queryData?.clientOrderDetails?.totalCost) : (installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId) ? formData?.payAmount : formData?.amount)),
    paidAmt : isLaterDueToday ? subs?.totalAmount : portalFinalAmount !== null ? portalFinalAmount :paymentData?.splitAmount ? paymentData?.splitAmount : queryData?.paymnetFromIntake === "true" ? (queryData?.clientOrderDetails?.paidAmt) : (installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId) ? formData?.payAmount : formData?.amount),
    paymentTypeId: queryData?.paymnetFromIntake === "true" ? (queryData?.clientOrderDetails?.paymentTypeId) : formData?.paymentTypeId ? formData?.paymentTypeId : (formData?.paymentMethod == "cash" ? 2 : formData?.paymentMethod == 'check' ? 4 : formData?.paymentMethod == 'ACH' ? 6 : 1),
    currencyTypeId: 2,
    isActive: false,
    createdBy: orderLoggedUserId,
    isBillDetail: true,
    responsibleAttorney: formData?.responsibleAttorney || null,
    originatingAttorney: formData?.originatingAttorney || null,
    responsibleAttorneyPer: formData?.responsiblePercentage || null,
    originatingAttorneyPer: formData?.originationPercentage || null,
    tenantId: isFederalWayPlaza && selectedUserData?.tenantId
      ? selectedUserData?.tenantId
      : null,
    totalDiscount: paymentData?.totalDiscount || null,
    // accountTypeId:Number(paymentAccount) || 1,
    AccountType: paymentData?.splitAmount ? JSON.stringify(splitCards[paymentData?.splitCardnumber ? paymentData?.splitCardnumber : 0]?.accounts) : formData?.AccountType ? JSON.stringify(formData?.AccountType) : JSON.stringify(paymentAccountfilter),
    productList:queryData?.paymnetFromIntake === "true" && paymentData?.splitAmount ? splitAMAproductList : queryData?.paymnetFromIntake === "true" ? queryData?.clientOrderDetails?.productList : [
      {
        productType: "SUBSCRIPTION",
        productId: formData?.linesOfBusiness || formData?.lineOfBusiness, // memberId
        productName: (paymentData?.lineOfBusiness == '9' || paymentData?.lineOfBusiness == '21')  ? formData?.subscriptionName : formData?.serviceName || "",
        quantity: 1,
        productPrice:paymentData?.splitAmount ? paymentData?.splitAmount : ( installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId) ? formData?.payAmount : formData?.amount) || 0,
        totalProductPrice: paymentData?.splitAmount ? paymentData?.splitAmount : (installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId)? formData?.payAmount : formData?.amount)|| 0 ,
        paidProductPrice: paymentData?.splitAmount ? paymentData?.splitAmount : ( installmentpay == 1 || !isNullUndefine(paymentData.userAuthSubId) ? formData?.payAmount : formData?.amount) || 0,
        isActive: true
      }
    ],
    chequeDetailsList: [formData?.paymentMethod == 'check' ? {
     "chequeNo": formData?.checkNumber,
     "chequeDate":formData?.checkDate ,
      "chequeAmount": formData?.amount,
      "chequeStatusId": 2,
      "createdBy": orderLoggedUserId || createdByForOrder
    }:formData?.paymentMethod == 'ACH' ? {
      // "chequeAmount": formData?.amount,
      // "chequeStatusId": 2,
      "createdBy": orderLoggedUserId || createdByForOrder,
      "accountNo":formData?.accountNumber,
      "routingNumber":formData?.routingNumber,
      "accountName":formData?.accountName,
      "bankName":formData?.bankName
    } : {}],
    isRefund:formData?.isRefund ? formData?.isRefund : false,
    refundBasedOrderId: formData?.refundBasedOrderId ? formData?.refundBasedOrderId : null
  };
};

const generateConfrimOrderJson = (userId, memberId, orderId, loggedUserId, paymentType, updatedreceiptCashpayment) => {
  return {
    userId :userId ,
    memberId : memberId,
    orderId,
    transactionId: "NA",
    paymentType,
    updatedBy: loggedUserId,
    receiptHTML: updatedreceiptCashpayment,
    paymentDate : paymentData?.paymentDate
  };
};

 const getTomorrowDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 1);
    return today.toISOString().split('T')[0];
  };

const generateSubscriptionJson = (selectedUserData,paymentData,orderId,userAuthSubId,id,recurringdata) => {
  const {serviceName,lineOfBusiness,paymentMethod,amount,subscriptionName,responsibleAttorney,originatingAttorney,totalDiscount, installmentNumber} = paymentData
     const queryParams = new URLSearchParams(window.location.search);
      const trxnStatus = queryParams.get('TrxnStatus');
      const orderIdFromQuery = queryData?.OrderId || queryData?.orderId || queryData?.orderID || null;
      const resolvedDiscount = totalDiscount !== undefined && totalDiscount !== null ? Number(totalDiscount) : Number(queryData?.subsDetails?.[0]?.totalDiscount ?? 0);
      const subs = queryData?.subsDetails?.[0];
      const fixedAmount = queryData?.paymnetFromIntake === "true" ? Number(subs?.totalAmount || 0) : Number((amount || '').toString().replace(/,/g, ""));
      const fixedDiscount = typeof resolvedDiscount === "string" ? Number(resolvedDiscount.replace(/,/g, "")) : Number(resolvedDiscount);
      const calculatedTotalAmount = queryData?.paymnetFromIntake === "true" ? fixedAmount : paymentData?.totalDiscount ? paymentData?.amount : fixedAmount + Number(fixedDiscount || 0);
      const sessionPaymentMethod = sessionStorage.getItem("PaymentMethod");
      const storedOrderId = sessionStorage.getItem("orderId");
      const { subscriptionId, subscriptionModeId, missedRenewals, limitedFreeNoOfYears } = queryData?.subsDetails?.[0] || {};
      const paymentSchedule = typeof missedRenewals === 'string' ? JSON.parse(missedRenewals)?.paymentSchedule : missedRenewals?.paymentSchedule;
      const isValidSchedule = subscriptionId === 1 && subscriptionModeId === 4 && (paymentSchedule === "Now" || paymentSchedule === "Later");
      const isValidScheduleLimitedFree = subscriptionId === 1 && subscriptionModeId === 3 && limitedFreeNoOfYears;
      const totalInstallmentNumber = queryData?.paymnetFromIntake === "true" ? installmentNumber ? installmentNumber : subs?.totalInstallment : paymentData?.installmentNumber
      const missedRenewalsObj = subs?.missedRenewals ? JSON.parse(subs.missedRenewals) : null;
      const isMissedRenewalHaveNumber = subs?.subscriptionId === 1 && subs?.subscriptionModeId === 4 && missedRenewalsObj?.paymentSchedule === "Later" ? Number(missedRenewalsObj?.amount || 0) * (Number(missedRenewalsObj?.number || 0) + 1) : null;
      const totalAmountForSpecialCase = ( subs?.subscriptionId === 1 && subs?.subscriptionModeId === 4 && missedRenewalsObj?.paymentSchedule === "Now" ) ? Number(missedRenewalsObj?.amount || 0) * Number(missedRenewalsObj?.number || 1) : calculatedTotalAmount;

  return {
    UserSubscriptionId: queryData?.paymnetFromIntake === "true" ? queryData?.subsDetails?.[0]?.userSubscriptionId : null,
    userAuthSubId: userAuthSubId || paymentData.userAuthSubId,
    userId: selectedUserData?.memberId || id,
    totalDiscount: paymentData?.totalDiscount ? paymentData?.totalDiscount : (resolvedDiscount || null),
    authSubscriptionId: recurringdata?.authorizeSubscriptionId || null,
    cutomerProfileId: recurringdata?.authorizeCustomerProfileId || null,
    paymentProfileId: recurringdata?.authorizePaymentProfileId || null,
    subscriptionId: lineOfBusiness,
    subscriptionName: queryData?.paymnetFromIntake === "true" ? paymentData?.subscriptionName : (lineOfBusiness == 9 ? subscriptionName || 'Other'  : serviceName || null),
    responsibleAttorney: responsibleAttorney || paymentData?.responsibleAttorney,
    originatingAttorney: originatingAttorney || paymentData?.originatingAttorney,
    authSubsStartDate: (todayLocal() || null),
    totalAmount: isMissedRenewalHaveNumber ? isMissedRenewalHaveNumber :(totalAmountForSpecialCase || null),
    paymentType: paymentMethod == "cash" ? 2 : paymentMethod == 'check' ? 4 : paymentMethod == 'ACH' ? 6 : 1,
    notes: paymentData?.notes || null,
    isActive: splitPaymentno != 'Yes' &&  trxnStatus == 'CANCELLED' ? false : true,
    isDelete: splitPaymentno != 'Yes' && trxnStatus == 'CANCELLED' ? true :  false,
    upsertedBy: loggedUserId || selectedUserData?.memberId || id,
    authLength: (paymentData?.installmentFrequencies == '-1' ? null : paymentData?.installmentFrequencies == 4 ? 7 : paymentData?.installmentFrequencies) || null,
    authSubsEndDate: null,
    authUnit: paymentData?.authUnit || "days",
    installmentAmount: installmentAmount?.toFixed(2) || null,
    installmentStartDate: paymentData?.installmentDate || null,
    totalOccurrence: totalInstallmentNumber,
    serviceMatNo : paymentData?.serviceMatNo,
    sourceTypeId: paymentData?.sourceType || paymentData?.sourceTypeId || null,
    authSubsInstallments:
      queryData?.paymnetFromIntake === "true"
      ? ((sessionPaymentMethod === "card" && ["onlyFee", "AMA&Fee","onlyProbate","onlyAMA"].includes(queryData?.subscriptionType)) || (sessionPaymentMethod === "card" && (isValidSchedule || isValidScheduleLimitedFree) && ["onlyAMA"].includes(queryData?.subscriptionType)))
      ? (storedOrderId || orderId || orderIdFromQuery
          ? [
              {
                authSubInstallmentId: 0,
                orderId: storedOrderId ? storedOrderId : orderId ? orderId : orderIdFromQuery,
                payAmount: paymentData?.payAmount,
                payAmountDate: (todayLocal() || null),
                notes: paymentData?.notes || null,
                isActive: true
              }
            ]
          : [])
        : sessionPaymentMethod === "card"
          ? []
          : (storedOrderId || orderId || orderIdFromQuery
          ? [
            {
              authSubInstallmentId: 0,
              orderId: storedOrderId ? storedOrderId : orderId ? orderId : (orderIdFromQuery),
              payAmount: paymentData?.payAmount,
              payAmountDate: (todayLocal() || null),
              notes: paymentData?.notes || null,
              isActive: true
            }
          ]
          : [])
        : (orderId && orderId !== 0
          ? [
            {
              authSubInstallmentId: 0,
              orderId: orderId,
              payAmount: paymentData?.payAmount,
              payAmountDate: (todayLocal() || null),
              notes: paymentData?.notes || null,
              isActive: true
            }
          ]
          : []),
    userAuthSubsTypes: paymentData?.company == "aging_options" ? paymentData?.lineOfBusiness == 12 ? paymentData?.components?.filter((comp => {return comp?.checked == true}))?.map((comp)=>{
      return {
      "userAuthSubsTypeId": 0,
      "subsSubTypeId": comp?.subsSubTypeId,
      "description": comp?.subsSubTypeId == 12 ? paymentData.otherDescription : '',
      "isActive": true
    }
    }) : [{
      "userAuthSubsTypeId": 0,
      "subsSubTypeId": paymentData.productType,
      "description": paymentData.description,
      "isActive": true
    }] : []
  };
};

//////////////////////////////////////  functios///////////////////


 const addOrderUser = async(selectedUserData, formData)=>{
  return new Promise(async(resolve, reject) => {
    const jsonObj = generateOrderJson(selectedUserData, formData);
    const addOrder = Services?.postAddUserOrderservice(jsonObj)
    addOrder.then((res)=>{
      const orderId = res?.data?.data?.order?.orderId
      if (orderId && queryData?.paymnetFromIntake === "true") {
        sessionStorage.setItem("orderId", orderId);
      }
    resolve(res?.data?.data?.order)
      //  setOrderIdData(_addOrderUser?.data?.data?.order)
    }).catch((err)=>{
    resolve('err')
    })
  })
 }

 const confirmOrder = async(userId, memberId, orderId, loggedUserId, paymentType,updatedreceiptCashpayment)=>{
  return new Promise(async(resolve, reject) => {
    const confrimOrderJson = generateConfrimOrderJson(userId, memberId, orderId, loggedUserId, paymentType,updatedreceiptCashpayment)
    const confrimOrder = Services?.postconfirmUserOrderservice(confrimOrderJson)
    confrimOrder.then((res)=>{
    resolve(confrimOrder)
    }).catch((err)=>{
    resolve('err')
    })
  })
 }

 const userAuthSubs = async(selectedUserData,paymentData,orderId,userAuthSubId,recurringdata,type)=>{
  return new Promise(async(resolve, reject) => {

    const authsubsJaon = generateSubscriptionJson(selectedUserData,paymentData,orderId,userAuthSubId,'',recurringdata)
    // return;
      let recurringData = JSON.parse(sessionStorage.getItem('recursionData'))
      if(recurringData){
        // authsubsJaon["authSubscriptionId"] = recurringData?.authSubscriptionId
        authsubsJaon['installmentAmount'] = recurringData?.installmentAmount
        authsubsJaon['installmentStartDate'] = recurringData?.installmentStartDate
        authsubsJaon['totalOccurrence'] = recurringData?.totalOccurrence
        authsubsJaon['authLength'] = recurringData?.authLength
      }
    if (queryData?.paymnetFromEventCoordinator == "true") {
      authsubsJaon['subscriptionName'] = queryData?.subscriptionName
    }

    const _userAuthSubs = Services?.upserUserAuthSubs(authsubsJaon)
    _userAuthSubs.then(async(res)=>{
      const newUserAuthSubId = res?.data?.data?.[0]?.userAuthSubId || null;
      if (newUserAuthSubId && queryData?.paymnetFromIntake === "true") {
        sessionStorage.setItem("userAuthSubId", newUserAuthSubId);
        setUserAuthSubIdState(newUserAuthSubId);
      }

      if(type == 'payReipet'){
              const result_data = await get_PaymentRecipet(orderId,selectedUserData?.memberId);
      if(result_data?.receiptHTML != null){
         const cleanedHtml = result_data?.receiptHTML
            .replace(/<html[^>]*>/gi, '')
            .replace(/<\/html>/gi, '')
            .replace(/<head[^>]*>.*?<\/head>/gis, '')
            .replace(/<body[^>]*>/gi, '')
            .replace(/<\/body>/gi, '');
          setInvoiceHtml(cleanedHtml);
      setOpenRecipetModal(true)
      }
      }




    resolve(res)
    }).catch((err)=>{
    resolve('err')
    })
  })
 }
  const returnPaymentRecipet = () => {
    let issplitPayment = sessionStorage?.getItem('userDeatils') ? JSON?.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
    let queryData = JSON?.parse(sessionStorage.getItem('queryData'))
    const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
    const raw = sessionStorage.getItem("userDeatils");
    const user = isJSON(raw) ? JSON.parse(raw) : {};
    const split = user?.splitCards;
    const cards = isJSON(split) ? JSON.parse(split) : [];

    return (
      <>
        <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${(issplitPayment != false && queryData?.paymnetFromIntake != 'true') || (queryData?.paymnetFromIntake == 'true' && (cards?.length == user?.splitCardnumber || cards?.length > user?.splitCardnumber)) ? 'invisible' : ''}`}>
          <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center px-6 py-4 border-b">
              <h4 className="text-lg font-bold">
                {/* Payment Recipet */}
                {`Client Service Billing - ${selectedUserData?.fullName} ${isNotValidNullUndefile(selectedUserData?.primaryEmail) ?  `(${selectedUserData?.primaryEmail})` : '' }`}
              </h4>
              <div className="flex items-center">
                {/* {!payremaningModal && !openModal && !sepratepayment && lastIndex === 0 && ( */}
                <>
                  <button
                    className="bg-blue-600 text-white px-3 py-1 rounded text-sm mr-2"
                    onClick={handlePrint}
                  >
                    Print
                  </button>
                  <button
                    className="bg-green-600 text-white px-3 py-1 rounded text-sm mr-4"
                    onClick={() => handleDownload()}
                  >
                    Download
                  </button>
                </>
                {/* )} */}
                {cards?.length != user?.splitCardnumber && <h4
                  // src="/icons/cross.png"
                  // alt="Close"
                  className="w-5 h-5 cursor-pointer"
                  onClick={handleClose}
                >X</h4>}
              </div>
            </div>

            <div className="p-4">
              <div ref={invoiceRef} className="max-w-4xl mx-auto p-4 bg-white shadow rounded overflow-auto" style={{ maxHeight: "30rem" }}>
                <div dangerouslySetInnerHTML={{ __html: invoiceHtml }} />
                <div
                  id="print-container"
                  style={{
                    position: 'absolute',
                    left: '-9999px',
                    top: 0,
                    width: '794px', // exact A4 size in px (210mm at 96dpi)
                    padding: '0',
                    margin: '0',
                    backgroundColor: '#fff', // Optional: ensure white background
                  }}
                  dangerouslySetInnerHTML={{ __html: invoiceHtml }}
                />
              </div>

            </div>
          </div>
        </div>
      </>
    )
  }

 const upsertUserLegalStaff = (formData) => {
    if(currentCompany?.name!="Life Point Law")return // Only execute for LPL

  let jsonObj = [{
      "userLegalStaffId": 0,
      "isActive": true,
      "isDeleted": false,
      "primaryUserId": selectedUserData?.memberId,
      "legalUserId": formData?.originatingAttorney,
      "staffTypeId": 4,
      "upsertedBy": loggedUserId || selectedUserData?.memberId
    },{
      "userLegalStaffId": 0,
      "isActive": true,
      "isDeleted": false,
      "primaryUserId": selectedUserData?.memberId,
      "legalUserId": formData?.responsibleAttorney,
      "staffTypeId": 1,
      "upsertedBy": loggedUserId || selectedUserData?.memberId
    }]
  let upsertUserLegalStaffpromise = Services.upsertUserLegalStaff(jsonObj)
  upsertUserLegalStaffpromise.then((res)=>{
    konsole.log(res,"upsertUserLegalStaffpromise")
  }).catch((err)=>{
    konsole.log(err,"upsertUserLegalStaffpromise")
  })
 }

  const recurringErrorHandled = async ( jsonBody, callNo = 1 ) => {
    setuseLoader(true)
    let resp = await Services.postApiCallNew('POST', AoUrl.post_CreateUserRecurringSubscription, jsonBody);
    setuseLoader(false)
    konsole.log("recurringErrorHandled - call no.: " + callNo + " and response", resp);
    if(resp?.isError == "true" && resp?.resPonse?.status == 404 && callNo < 5) {
    resp = await recurringErrorHandled(jsonBody, callNo + 1);
    }
    return callNo == 1 ? (resp?.isError == "true" ? "err" : resp?.resPonse) : (resp);
    }


    const reportFunc = () => {
        // Handle refund states by checking selectedCompany directly
        if(selectedCompany == 'life_point_law' || selectedCompany == 'Refund' || currentCompany?.name == 'Life Point Law'){
      navigate('/Billing?subtenantId='+lplSubtinent)
    }else if(selectedCompany == 'aging_options' || selectedCompany == 'RefundAging' || currentCompany?.name == 'Aging Options'){
      navigate('/Billing?subtenantId=3')
    }else if(selectedCompany == 'federal_way_plaza' || selectedCompany == 'RefundFederal' || currentCompany?.name == 'Federal Way Professional Plaza'){
      navigate(`/Billing?subtenantId=${federal_way_plazaId}`)
    }else if(currentCompany?.name == 'Time matters'){
      navigate('/Billing?subtenantId='+time_mattersSubtinent)
    }
    else{
          navigate(`/Billing?subtenantId=${federal_way_plazaId}`)
        }
      }

  const handleClose = async (noNeedToRun) => {
    if (noNeedToRun === "noNeedToRun") {
      setOpenRecipetModal(true);
      let paymentRecipet = await get_PaymentRecipet(confirmOrderDetails?.data?.data?.order?.orderId, confirmOrderDetails?.data?.data?.userId)
      setInvoiceHtml(paymentRecipet?.receiptHTML)
      sessionStorage.removeItem('recursionData')
      return;
    }
    setOpenRecipetModal(false)
    setSplitPaymentno('No')
    setPaymentoption(1)
    setSplitcards([{ id: 1, amount: 0 }])
    setSelectedCompany(companyName)

    setTimeout(() => {
      setSplitPaymentno('No');
      setPaymentoption(1);
    }, 5000);

    sessionStorage.removeItem('recursionData');
    Object.keys(sessionStorage)
      ?.filter((k) => k.startsWith('invoiceUploaded_'))
      .forEach((k) => sessionStorage.removeItem(k));
    if (queryData?.paymnetFromEventCoordinator !== "true") {
      sessionStorage.removeItem('userDeatils');
      sessionStorage.removeItem('queryData');
    }
    const cameFromGateway = sessionStorage.getItem("isCameFromPaymentGateWay");

    if (openRecipetModal && cameFromGateway) {
      const queryParams = new URLSearchParams(window.location.search);
      const orderIdFromUrl = queryParams.get("OrderId");
      const trxnIdFromUrl = queryParams.get("TrxnStatus");
      const isLocalhost = window.location.hostname === "localhost";
      const baseUrl = (queryData?.fromPersonalInfo == "true") ? `${isLocalhost ? 'http://localhost:3000/' : intakeBaseUrl}setup-dashboard/PersonalInfo` : isLocalhost
        ? "http://localhost:3000/paralegal"
        : `${intakeBaseUrl}paralegal`;
      const PTandAuth = JSON.parse(sessionStorage.getItem("userPaymentTypeandAuth")) || {};
      const newAuthId = PTandAuth?.userAuthSubId;
      const newPaymentType = PTandAuth?.paymentMethod;
      const stateObj = JSON.parse(sessionStorage.getItem('userDeatils')) || {};
      const { userAuthSubId } = stateObj
      const finalUserAuthSubId = newAuthId || userAuthSubId || "";
      const userParam = finalUserAuthSubId
        ? `&UserAuthSubId=${finalUserAuthSubId}`
        : "";
      const sessionPaymentMethod = sessionStorage.getItem("PaymentMethod");
      const finalPaymentMethod =
        newPaymentType || sessionPaymentMethod || paymentData?.paymentMethod || "";
      const paymentMethod = finalPaymentMethod
        ? `&PaymentMethod=${encodeURIComponent(finalPaymentMethod)}`
        : "";
      if (orderIdFromUrl && trxnIdFromUrl && queryData?.paymnetFromEventCoordinator !== "true") {
        let recurringOrderId = sessionStorage.getItem("recurringOrderId");
        let paymentProfileId = sessionStorage.getItem("paymentProfileId");
        let paymentProfileIdAMA = sessionStorage.getItem("paymentProfileIdAMA");
        let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
        let additionurl = `&paymentProfileId=${paymentProfileId ? paymentProfileId : ''}`;
        let additionurlAMA = `&paymentProfileIdAMA=${paymentProfileIdAMA ? paymentProfileIdAMA : ''}`;
        const isAdvancePayment = sessionStorage.getItem('isAdvancePayment') === 'true';
        const advanceUrl = isAdvancePayment ? '&isAdvancePayment=true' : '';
        let advanceRecurringUrl = '';
        if (isAdvancePayment) {
          const advResult = JSON.parse(sessionStorage.getItem('advanceRecurringResult') || 'null');
          if (advResult?.authorizeSubscriptionId) {
            advanceRecurringUrl =
              `&authorizeSubscriptionId=${advResult.authorizeSubscriptionId}` +
              `&authorizeCustomerProfileId=${advResult.authorizeCustomerProfileId || ''}` +
              `&authorizePaymentProfileId=${advResult.authorizePaymentProfileId || ''}`;
          }
        }
        window.location.href = `${baseUrl}?OrderId=${recurringOrderId && issplitPayment != false ? recurringOrderId : orderIdFromUrl}&TrxnStatus=SUCCESS${paymentMethod}${userParam}${additionurl}${additionurlAMA}${advanceUrl}${advanceRecurringUrl}`;
        sessionStorage.removeItem('advanceRecurringResult');
      } else if (orderIdFromUrl && trxnIdFromUrl && queryData?.paymnetFromEventCoordinator == "true") {
        const storedData = JSON.parse(sessionStorage.getItem("queryData"));
        const consId = JSON.parse(sessionStorage.getItem("moConId") || "");
        redirectOnCoordinator(orderIdFromUrl, 1, isLocalhost, storedData, consId)
      } else {
        // return;
        window.location.href = `${baseUrl}${paymentMethod ? `?${paymentMethod?.slice(1)}` : ''}`;
      }
      sessionStorage.removeItem('recursionData')
      if (queryData?.paymnetFromEventCoordinator !== "true") {
        sessionStorage.removeItem("isCameFromPaymentGateWay");
        sessionStorage.removeItem('queryData')
      }
      return;
    }

    if (openRecipetModal) {
      redirectToIntake(true, confirmOrderDetails?.data?.data?.order?.orderId);
    }

    if (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== "true") {
      setOrderIdData(null);
      setTrxnStatus('');
      setConfirmOrderDetails(null);
      setInvoiceHtml('');
      sessionStorage.removeItem('orderId');
      sessionStorage.removeItem('PaymentMethod');

      const url = new URL(window.location.href);
      if (url.searchParams.has('OrderId') || url.searchParams.has('TrxnStatus')) {
        url.searchParams.delete('OrderId');
        url.searchParams.delete('TrxnStatus');
        window.history.replaceState({}, '', url.toString());
      }
    }
    sessionStorage.removeItem('recursionData')
    if (queryData?.paymnetFromEventCoordinator !== "true") {
      sessionStorage.removeItem("userDeatils");
      sessionStorage.removeItem('queryData')
    }
  }

  //Redirect To Intake
  const redirectToIntake = (includeStatus = false, orderId = '') => {
    if (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== "true") return;
    const isLocalhost = window.location.hostname === 'localhost';
    const baseUrl = (queryData?.fromPersonalInfo == "true") ? `${isLocalhost ? 'http://localhost:3000/' : intakeBaseUrl}setup-dashboard/PersonalInfo` : isLocalhost
      ? "http://localhost:3000/paralegal"
      : `${intakeBaseUrl}paralegal`;
    const sessionPaymentMethod = sessionStorage.getItem("PaymentMethod");
    const paymentMethod =
      sessionPaymentMethod || paymentData?.paymentMethod
        ? `&PaymentMethod=${encodeURIComponent(sessionPaymentMethod || paymentData.paymentMethod)}`
        : '';
    const stateObj = JSON.parse(sessionStorage.getItem('userDeatils')) || {};
    const { userAuthSubId } = stateObj
    const userParam = userAuthSubId ? `&UserAuthSubId=${userAuthSubId}` : '';

    const isAdvancePayment = sessionStorage.getItem('isAdvancePayment') === 'true';
    const advanceUrl = isAdvancePayment ? '&isAdvancePayment=true' : '';
    let advanceRecurringUrl = '';
    if (isAdvancePayment) {
      const advResult = JSON.parse(sessionStorage.getItem('advanceRecurringResult') || 'null');
      if (advResult?.authorizeSubscriptionId) {
        advanceRecurringUrl =
          `&authorizeSubscriptionId=${advResult.authorizeSubscriptionId}` +
          `&authorizeCustomerProfileId=${advResult.authorizeCustomerProfileId || ''}` +
          `&authorizePaymentProfileId=${advResult.authorizePaymentProfileId || ''}`;
      }
    }

    if (includeStatus && orderId && queryData?.paymnetFromIntake == "true") {
      let recurringOrderId = sessionStorage.getItem("recurringOrderId");
      let paymentProfileId = sessionStorage.getItem("paymentProfileId");
      let paymentProfileIdAMA = sessionStorage.getItem("paymentProfileIdAMA");
      let additionurl = `&paymentProfileId=${paymentProfileId ? paymentProfileId : ''}`;
      let additionurlAMA = `&paymentProfileIdAMA=${paymentProfileIdAMA ? paymentProfileIdAMA : ''}`;
      let issplitPayment = sessionStorage.getItem('userDeatils') ? JSON.parse(sessionStorage.getItem('userDeatils'))?.splitPayment : false;
      window.location.href = `${baseUrl}?OrderId=${recurringOrderId && issplitPayment != false ? recurringOrderId : orderId}&TrxnStatus=SUCCESS${paymentMethod}${userParam}${additionurl ? additionurl : ''}${additionurlAMA ? additionurlAMA : ''}${advanceUrl}${advanceRecurringUrl}`;
      sessionStorage.removeItem('advanceRecurringResult'); // NEW

    } else if (includeStatus && orderId && queryData?.paymnetFromEventCoordinator == "true") {
      redirectOnCoordinator(orderId, paymentMethod, isLocalhost, queryData)
    }
    else {
      if (queryData?.paymnetFromEventCoordinator == "true") {
        setuseLoader(true)
        const queryParams = new URLSearchParams(window.location.search);
        const encodedData = queryParams.get("moConId");
        const baseUrl1 = `${CounterBaseUrl}Dashboard`
        const redirectUrl = `${baseUrl1}?moConId=${encodedData}`
        window.location.href = redirectUrl
      } else {
        window.location.href = `${baseUrl}${paymentMethod ? `?${paymentMethod?.slice(1)}` : ''}`;
      }
    }
  };

const handlePrint = () => {
  if (!invoiceRef.current) return;
  handleDownload(true)
  // const w = window.open('', '_blank');
  // w.document.write(`<body>${invoiceRef.current.innerHTML}</body>`);
  // w.document.close();
  // w.print()
};

const redirectOnCoordinator = async (orderId,paymentMethod,isLocalhost,queryDatas,storedData) => {
    const queryParams = new URLSearchParams(window.location.search);
    const encodedData = queryParams.get("moConId") || storedData;
    const loginUserId = getLoggedUserId() || loggedUserId || resolveLoggedUserIdFromPayload(queryDatas) || queryDatas?.loggedUserId || queryDatas?.UpsertedBy || queryDatas?.createdBy || null;
    const dataToEncode = {
      UserId: queryDatas?.UserId,
      subtenatName: queryDatas?.subtenatName,
      loggedUserId: loginUserId,
      createdBy: queryDatas?.createdBy,
      UpsertedBy: loginUserId,
      totalCost: queryDatas?.amount,
      userLoggedInDetail: queryDatas?.userLoggedInDetail,
      subtenantId: queryDatas?.subtenantId,
      OrderId:orderId,
      paymentMethod: paymentMethod,
      TrxnStatus : "SUCCESS",
      queryData:queryDatas
    };

    let jsonObj = {
      "moConId": encodedData,
      "moduleConnectionRequest": '',
      "moduleConnectionResponse": JSON.stringify(dataToEncode),
      "isActive": true,
      "requestedFor": queryData?.UserId,
      "upsertedBy": loginUserId
    }
    sessionStorage.removeItem("isCameFromPaymentGateWay");
    sessionStorage.removeItem('queryData')
    setuseLoader(true)
    const getModuleConnectparams = await Services.upsertModuleConnectservice(jsonObj)
      setTimeout(()=>{
        // const baseUrl1 = `${isLocalhost ? 'http://localhost:3000/confirmBooking' : queryDatas?.ReturnUrl}`
        const baseUrl1 = `${queryDatas?.ReturnUrl}`
        const redirectUrl = `${baseUrl1}?moConId=${encodedData}`
        window.location.href = redirectUrl
      },[1000])
  }

 const handleDownload = async ( isPrint ) => {
  const content = document.getElementById('print-container');
  if (!content) return;

  const html2pdf = (await import('html2pdf.js')).default;
  html2pdf().from(`<body>${invoiceRef.current.innerHTML}</body>`).set({
      margin: [10, 0, 10, 0],
      filename: `Invoice.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 1.5, useCORS: true, allowTaint: true, logging: true, scrollX: 0, scrollY: -window.scrollY, windowWidth: document.documentElement.scrollWidth, windowHeight: document.documentElement.scrollHeight },
      jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    }).toPdf().get('pdf').then(pdf => {
      if(isPrint) {
        // Assuming 'pdfBlob' is your PDF Blob object
        const pdfBlob = pdf.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);

        { // from same window
          const iframePdf = document.createElement('iframe');
          iframePdf.src = pdfUrl;
          iframePdf.style.display = 'none';
          iframePdf.onload = function() {
            setTimeout(() => {
              // iframePdf.contentWindow.focus();
              iframePdf.contentWindow.print();
            }, 500);

            const cleanup = () => {
              window.removeEventListener('focus', cleanup);
              document.body.removeChild(iframePdf);
              URL.revokeObjectURL(pdfUrl);
            };

            window.addEventListener('focus', cleanup);
          };
          document.body.appendChild(iframePdf);
        }
      } else {
        pdf.save(`Invoice.pdf`);
      }
    }).catch(err => {
      konsole.log("pdf_download_err", err);
    });
 }

  const uploadFilefunc = async () => {
  const content = document.getElementById('print-container');
  if (!content) return;

  const orderIdForUpload = orderIdData?.orderId || confirmOrderDetails?.data?.data?.order?.orderId || sessionStorage.getItem('orderId') || queryData?.OrderId || queryData?.orderID;
  const uploadKey = `invoiceUploaded_${orderIdForUpload}`;
  if (orderIdForUpload && sessionStorage.getItem(uploadKey) === 'true') {
    return;
  }

  html2pdf()
  .from(`<body>${invoiceRef.current.innerHTML}</body>`)
  .set({
    margin: [10, 0, 10, 0],
    filename: `Invoice.pdf`,
    image: { type: 'jpeg', quality: 1 },
    html2canvas: {
      scale: 1.5,
      useCORS: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
      backgroundColor: "#fff",
      logging: false,
    },
    jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
  })
  .toPdf()
  .get('pdf')
  .then(async (pdf) => {
    // ✅ Convert to Blob
    const pdfBlob = pdf.output('blob');
    const file = new File([pdfBlob], 'Invoice.pdf', { type: 'application/pdf' });
    const stateObj = JSON.parse(sessionStorage.getItem('userDeatils')) || {};
    if (orderIdForUpload) {
      sessionStorage.setItem(uploadKey, 'true');
    }


  let jsonObj = {
    File: file,
    UploadedBy: '',
    UserId: selectedUserData?.memberId || stateObj?.userId,
    FileTypeId:93,
    FileCategoryId:6,
    UserFileName: queryData?.subscriptionType === "AMA&Fee"
      ? "Legal LifePlanning - Fee Agreement - Receipt"
      : `${paymentData?.subscriptionName || (paymentData?.lineOfBusiness == '9' ? (paymentData?.subscriptionName || '') : (paymentData?.serviceName || '')) || (stateObj?.serviceName || '')} - Receipt`
    }

  let postJson = appendFormData(jsonObj)
  console.log(postJson,"postJsonjsonObj",jsonObj,selectedUserData)
  setuseLoader(true)
  const url = BASE_URL_New + '/api/2/FileUpload/uploadUserDocuments'
  const postUploadFile = await Services.postApiCallNew('POST',url,postJson)
  setuseLoader(false)
  konsole.log(postUploadFile,"postUploadFile")
  // if(currentCompany.name!="Life Point Law")return
  if (postUploadFile?.isError == "true" && orderIdForUpload) {
    sessionStorage.removeItem(uploadKey);
  }
  await withFileCabinetParalegalPermissions(postUploadFile,selectedUserData?.memberId || stateObj?.userId)
  })
 }

  const withFileCabinetParalegalPermissions = async (props,userId) => {
        konsole.log("withFileCabinetProps", props)

        const uploadData = props?.resPonse?.data?.data;
        const uploadedFileId = uploadData?.fileId ?? uploadData?.[0]?.fileId ?? props?.resPonse?.data?.fileId;
        if (props?.isError == "true" || !isNotValidNullUndefile(uploadedFileId)) {
            konsole.log("Upload failed or fileId missing, skipping UserFileCabinet/Add", props);
            return;
        }

        const fetchFolders = async (belongsToMemberId) => {
            setuseLoader(true)
            const result = await Services.postApiCallNew("POST", AoUrl.getFileCabinetFolderDetails, { belongsTo: belongsToMemberId });
            setuseLoader(false)
            const folderData = result?.resPonse?.data?.data;
            return Array.isArray(folderData)
                ? folderData.filter((item) => item.belongsTo == belongsToMemberId && item?.folderFileCategoryId == 6 && item.folderCabinetId == 1)
                : [];
        }

        const findCurrentFolder = (folders) => {
            if (!Array.isArray(folders) || folders.length == 0) return null;
            setAllFolderList(folders)
            const nested = createNestedArray(folders);
            setLegalCategoryLifePlanFolderId(nested)
            const lpl = nested?.find((e) => e.folderName == 'Life Point Law');
            const fee = lpl?.folder?.find((e) => e.folderName == 'Fee Agreement & Other Forms');
            const current = fee?.folder?.find((e) => e.folderName == 'Current');
            return current || null;
        }

        const upsertFolderCabinetMapping = async (belongsToMemberId) => {
            const _upsertFolderJson = {
                folderFileCategoryId: 6,
                belongsTo: belongsToMemberId,
                folderCreatedBy: belongsToMemberId,
                folderOperation: "Map All Folders In Category",
                folderSubtenantId: lplSubtinent,
                folderRoleId: 3,
                folderCabinetId: 1,
                autoMapProfessionalFolderId: 6
            }
            setuseLoader(true)
            const result = await Services.postApiCallNew("POST", AoUrl.upsertCabinetFolder, [_upsertFolderJson])
            setuseLoader(false)
            konsole.log("_resultUpsertFolderMapping", result)
            return result;
        }

        const addFiletoFilecabinet = async (folder) => {
          const jsonObj = {
            "primaryUserId":userId,
            "fileId":uploadedFileId,
            "fileCategoryId":6,
            "fileStatusId":2,
            "fileTypeId":93,
            "fileUploadedBy":userId,
            "cabinetId":1,
            "isActive":true,"isShared":false,
            "isMandatory":false,"isFolder":true,
            "isCategory":true,"folderId":folder?.folderId,
            "belongsTo":[{"fileBelongsTo":userId}],
            "isClientVisible":true
          }
          setuseLoader(true)
          let responseAddfile = await Services.postApiCallNew('POST',AoUrl.addfiletoFilecabinet,jsonObj)
          if (responseAddfile?.isError == "true") {
            konsole.log("UserFileCabinet/Add failed, retrying once", responseAddfile)
            responseAddfile = await Services.postApiCallNew('POST',AoUrl.addfiletoFilecabinet,jsonObj)
          }
          setuseLoader(false)
          if (responseAddfile?.isError == "true") {
            console.error("UserFileCabinet/Add failed", { fileId: uploadedFileId, folderId: folder?.folderId, responseAddfile })
          }

          const isJSON = (s) => { try { JSON.parse(s); return true } catch { return false } };
          const raw = sessionStorage.getItem("userDeatils");
          const user = isJSON(raw) ? JSON.parse(raw) : {};
          const split = user?.splitCards;
          const cards = isJSON(split) ? JSON.parse(split) : [];
          function calculateCompletedAmount(arr) {
            return arr
              .reduce((total, item) => total + Number(item.amount), 0);
          }

          let cardTotal = calculateCompletedAmount(cards)
          let totalAmount = isNotValidNullUndefile(queryData?.clientOrderDetails?.totalCost) ? removeCommas(queryData?.clientOrderDetails?.totalCost) : queryData?.subsDetails?.[0]?.totalAmount
          let userDeatilsession = JSON.parse(sessionStorage.getItem('userDeatils'))

          if(queryData?.paymnetFromIntake == 'true' && cards?.length == user?.splitCardnumber && cardTotal == totalAmount){
            setuseLoader(true)
            let delayTime =  queryData?.installmentAmountAMA != null && userDeatilsession?.splitCardnumber == userDeatilsession?.recurringCardAMAfee ? 15000 : 2000
            setTimeout(() => {
              handleClose();
              sessionStorage.removeItem('recursionData')
              sessionStorage.removeItem('queryData')
            },queryData?.subscriptionType == "AMA&Fee" ? delayTime :2000);
          }
          setuseLoader(false)
          konsole.log(responseAddfile,"responseAddfile")
        }

        let folders = await fetchFolders(userId);
        let currentFolder = findCurrentFolder(folders);
        if (!currentFolder) {
            await upsertFolderCabinetMapping(userId);
            folders = await fetchFolders(userId);
            currentFolder = findCurrentFolder(folders);
        }
        if (!currentFolder) {
            console.error("Current folder not found, file not added to File Cabinet", { fileId: uploadedFileId, userId });
            return;
        }
        await addFiletoFilecabinet(currentFolder)
    }

    const openExcel = () =>{

    setShowExcle(true)
    }

    useEffect(() => {
      if (openRecipetModal && invoiceHtml !== '' && (SubtenantIde !== federal_way_plazaId)) {
        const checkDOM = setInterval(() => {
          const content = document.getElementById('print-container');
          if (content) {
            clearInterval(checkDOM);
            uploadFilefunc();
          }
        }, 100);

        return () => clearInterval(checkDOM);
      }
    }, [invoiceHtml, openRecipetModal]);

  if (!isQueryDataLoaded) return null;
  if (!isNotValidNullUndefile(selectedCompany) && (!queryData || queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator !== 'true')) {
    return (
      <> 
      {/* Outside Main 3 tile page */}
        {useLoader && <div className='fixed inset-0 z-50 bg-white bg-opacity-30 backdrop-blur-sm  pointer-events-auto'>
          <Loader useLoader={useLoader} />
        </div>}
            {showExcle == true && <ExcleDashbord setuseLoader={setuseLoader} setShowExcle={setShowExcle} subtenantIdExcel={subtenantIdExcel} />}
        {showExcle == false && <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl w-full">

            <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
              Payment Processing System
            </h1>
            <p className="text-lg text-center mb-8 text-gray-600">
              Select which company you're processing payment for:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              {Object.entries(companies)?.map(([id, company]) => (
                <div
                  key={id}
                  onClick={() => handleCompanySelect(id)}
                  className={`${company.color} text-white p-6 rounded-lg cursor-pointer transform hover:scale-105 transition-transform shadow-md`}
                >
                  <h3 className="text-xl font-semibold text-center">
                    {company.name}
                  </h3>
                </div>
              ))}
            </div>
            {showExcle == false && (isClient !== true) && (isReportViewable == true) && <div className="flex justify-center mt-4">
            <button className="w-1/3 bg-[#720c20] text-white font-semibold py-2 px-2 rounded flex gap-2 justify-center items-center" onClick={()=>{openExcel(); setSubtenantIdExcel('All_Companies')}}><img className='mt-0 pt-0' width="30px" height="auto" src="/dashboardIcon1.png" />Dashboard</button>
            </div>}
          </div>
        </div>}
        {openRecipetModal && returnPaymentRecipet()}
        {toast && (<Toaster message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />)}

      </>
    );
  }

  const currentCompany = companies[selectedCompany];
  const confirmation = async () => {
    const userRes = await confirm(
      true,
      "To add your card, we need to verify your card details. A temporary charge of $0.01 will be applied and refunded...",
      "Confirmation",
      "custom",
      [
        { label: "Cancel", value: false },
        { label: "Proceed", value: true },
      ]
    );

    // if (userRes) {
    //   console.log("User accepted");
    // } else {
    //   console.log("User canceled");
    // }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSplitPayment= async (card,index) => {
     if (isProcessing) return;

      setIsProcessing(true);
    if(paymentData?.splitAmount == 0 || paymentData?.splitAmount == '' || paymentData?.splitAmount == null){
      setToast({ message: 'Please enter a valid amount.', type: 'error' });
      setIsProcessing(false);
      return;
    }
    let totalAccountamount = card?.accounts?.reduce((a, c) => Number(a) + Number(c.Amount), 0)
    if(card?.accounts?.length > 0 && card.amount != totalAccountamount){
      setToast({ message: 'Please enter a valid amount.', type: 'error' });
      setIsProcessing(false);
      return;
    }
    setSplitcards((prev) =>
    prev?.map((c, i) =>
      i === index ? { ...c, paymentStatus: 'Completed' } : c
    )
    );
    // setPaymentData({
    //   ...paymentData,
    //   splitAmount: card.amount
    // });
    setTimeout(()=>{
    handleSubmit()
    setIsProcessing(false);
    },1000)
  }

  const totalSplit = splitCards?.length > 0 && splitCards?.reduce(
    (sum, card) => sum + toNumber(card?.amount ?? 0),
    0
  );

  const isEqual = () => {
  const totalSplit = splitCards?.reduce(
    (sum, card) => sum + Number(card?.amount ?? 0),
    0
  );

  return totalSplit == paymentData?.amount;
}
const onsplitPayment = (e,setState)=>{
setState(e.target.value);
setPaymentData({...paymentData,splitAmount:''});

const valuePay = PaymentOption == 1 && isPayButton == false ? paymentData?.amount : paymentData?.payAmount

 if (e.target.value == "Yes" && paymentAccount.length > 0 && paymentAccount[0]?.AccountTypeId == 1 && isNotValidNullUndefile(toNumber(paymentAccount[0]?.Amount)) && toNumber(paymentAccount[0]?.Amount) != 0) {

    const amount = toNumber(valuePay);
    // Move to splitCards
    setSplitcards((prev) => [{id: 1,amount,accounts: [{AccountTypeId: 1,Amount: amount}]}]);
    // Reset paymentAccount
    setPaymentaccount([]);
    setPaymentData({...paymentData,splitAmount:amount});
  }
  else {
    setSplitcards((prev) => {
      const amount = toNumber(valuePay) ?? 0;
      // Restore paymentAccount safely
      setPaymentaccount([{ AccountTypeId: 1, Amount: amount }]);
      return [{ id: 1, amount: 0 }];
    });
  }


setRecurringCard('')
}
  const radioButton = (label, value, state, setState) => {
  return <label class="radio-label custom-radio">
    <input type="radio" name={label} disabled={issplitPaymentSession == true} value={value} checked={state == value} onChange={(e) => onsplitPayment(e,setState)} />
    {/* <div class="w-4 h-4 rounded-full border-2 border-gray-400 peer-checked:border-blue-600 peer-checked:bg-blue-600 transition"></div> */}
    <span class="ml-2 text-gray-700">{label}</span>
  </label>
}


const handleSplitInputChange = (e, index) => {
  const value = e.target.value.replace(/,/g, "");

  const updated = splitCards?.map((c, i) =>
    i === index ? { ...c, amount: value } : c
  );

  setSplitcards(updated);

  const safeNumber = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };

  const newTotalSplit = updated.reduce(
    (sum, item) => sum + safeNumber(item.amount),
    0
  );

  const limit = PaymentOption == 2 ? paymentData?.payAmount : paymentData?.amount
  // (Number(paymentData?.amount?.toString().replace(/,/g, '')) - (queryData?.paymnetFromIntake == 'true' ? 0 : safeNumber(paymentData?.totalDiscount)));

  if (isNullUndefine(limit) || Number(newTotalSplit?.toString().replace(/,/g, '')) > Number(limit?.toString().replace(/,/g, ''))) {
    setToast({
      message: "Please enter a valid amount.",
      type: "error",
    });
    const updated = splitCards?.map((c, i) =>
    i === index ? { ...c, amount: 0 } : c
  );

  setSplitcards(updated);
  if (index === 0) {
    setPaymentData({
      ...paymentData,
      splitAmount: 0,
    });
  }
  return;
  }

  if (index === 0) {
    setPaymentData({
      ...paymentData,
      splitAmount: value,
    });
  }
  if(index != 0 && paymentData.splitCardnumber >= 1){
     setPaymentData({
      ...paymentData,
      splitAmount: value,
    });
  }
};

 const chackboxButton = (label, value, card, setSplitCards, splitCards, paymentData, setToast) => {
  // Determine if the account type is already selected for this card
  const entry = card.accounts?.find((item) => item.AccountTypeId === value);
  const isChecked = !!entry;

  const handleCheckboxChange = (e) => {
    setSplitCards((prev) =>
      prev?.map((c) => {
        if (c.id !== card.id) return c;

        let updatedAccounts = c.accounts ? [...c.accounts] : [];
        if (e.target.checked) {
          updatedAccounts.push({ AccountTypeId: value, Amount: 0 });
        } else {
          updatedAccounts = updatedAccounts?.filter((a) => a.AccountTypeId !== value);
        }
        return { ...c, accounts: updatedAccounts };
      })
    );
  };

  const handleInputChange = (e) => {
    setSplitCards((prev) =>
      prev?.map((c) => {
        if (c.id !== card.id) return c;

        const updatedAccounts = c.accounts?.map((a) =>
          a.AccountTypeId === value ? { ...a, Amount: Number(e.target.value) } : a
        );

        const totalAmount = updatedAccounts.reduce((sum, acc) => sum + Number(acc.Amount), 0);
        if (totalAmount > Number(c.amount)) {
          setToast({ message: 'Please enter a valid amount.', type: 'error' });
          return c; // don't update if total exceeds
        }

        return { ...c, accounts: updatedAccounts };
      })
    );
  };

  return (
    <div className="mb-2 flex items-center space-x-3" style={{width: isChecked ? "20rem" : "10rem"}}>
      <label className="flex items-center">
        <input
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="mr-2"
        />
        <span>{label}</span>
      </label>
      {isChecked && (
        <div className="relative" style={{width:"50%"}}>
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
            <span className="text-gray-500">$</span>
          </div>
          <input
            type="type"
            value={formatToUS(entry?.Amount) || ''}
            onChange={handleInputChange}
            placeholder="Enter amount"
            // className="w-20 border border-gray-300 rounded-md px-2 py-2 pl-5"
            className="w-100 border py-2 rounded w-32 pl-6 px-2"
            style={{width:"100%"}}
          />
        </div>
      )}
    </div>
  );
};


const chackboxButtonAccount = (label, value, data, setData) => {
  const entry = data?.length > 0 && data?.find((item) => item.AccountTypeId === value);
  const isChecked = !!entry;

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setData([...data, { AccountTypeId: value, Amount: 0 }]);
    } else {
      setData(data?.filter((item) => item.AccountTypeId !== value));
    }
  };

  const handleInputChange = (e) => {
    const newData = data?.length > 0 && data?.map((item) =>
      item.AccountTypeId === value ? { ...item, Amount: (e.target.value) } : item
    );
    let calculateTotal = newData.reduce((a, c) => Number(a) + parseFloat(String(c.Amount)?.replace(/,/g, "")) , 0)
    let tAmount = PaymentOption == 1 ? paymentData?.amount : paymentData?.payAmount
    if (calculateTotal > parseFloat(String(tAmount)?.replace(/,/g, ""))) {
      setToast({ message: 'Please enter a valid amount.', type: 'error' });
      return
    }
    setData(newData);
  };


  return (
    <div className="mb-2 flex items-center space-x-3">
      <label className="flex items-center">
        <input
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="mr-2"
        />
        <span>{label}</span>
      </label>
      {isChecked && (
        <div className="relative w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
            <span className="text-gray-500">$</span>
          </div>
          <input
            type="text"
            value={formatToUS(entry?.Amount) || ""}
            onChange={handleInputChange}
            placeholder="0"
            min="0"
            step="1"
            className="w-100 border border-gray-300 rounded-md px-2 py-2 pl-5"
          />
        </div>
      )}
    </div>
  );
};
 const scrollToSection = () => {
    if (servicetyperef.current) {
      setTimeout(()=>{
      servicetyperef.current.scrollIntoView({ behavior: 'smooth' });
      },100)
    }
  };

  const handleAddCardButton = (indexes) => {
    const Amounts =  PaymentOption == 1 ? paymentData?.amount : paymentData?.payAmount
    if (toNumber(totalSplit) == toNumber(Amounts)) {
      setToast({ message: `The total amount is already allocated to the card.`, type: "error" });
      return;
    }
    // setSplitcards((prev) => [
    //   ...prev,
    //   { id: prev.length + 1, amount: 0 },
    // ])

    setSplitcards((prev) => {
      if (!prev[indexes]) return prev;

      // Calculate total used amount till sourceIndex
      const usedAmount = prev.slice(0, indexes + 1).reduce((sum, item) => sum + toNumber(item.amount || 0), 0);
      // Calculate remaining amount

      const remainingAmount = toNumber(Amounts) - usedAmount;
      // If nothing remaining, do nothing
      if (remainingAmount <= 0) return prev;
      const nextIndex = indexes + 1;
      const source = prev[indexes];
      const updated = [...prev];

      //Create / update next index with remaining amount
      updated[nextIndex] = {
        ...updated[nextIndex],
        id: nextIndex + 1,
        amount: remainingAmount,
        accounts: [
          {
            AccountTypeId: source.accounts?.[0]?.AccountTypeId,
            Amount: remainingAmount,
          },
        ],
      };
      return updated;
    });
  }



  return (
    <>

      {/* {isNotValidNullUndefile(props?.authToken) && <TopHead queryData={queryData} page={"Assignrole"} stateShow={stateShow} setStateShow={setStateShow}/>} */}

      {useLoader && <div className='fixed inset-0 z-50 bg-white bg-opacity-30 backdrop-blur-sm  pointer-events-auto'>
        <Loader useLoader={useLoader} />
      </div>}
      <div className="min-h-screen bg-gray-100 p-4">

        <div className="max-w-6xl mx-auto">
          {/* Header */}
         {userRegistration !== true && <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-bold text-gray-800">
                {queryData?.paymnetFromIntake === "true"
                  ? (subsDetails?.[0]?.subtenantName || queryData?.subsDetails?.[0]?.subtenantName || "AR") + " Payment" : queryData?.paymnetFromEventCoordinator == 'true' ? `Payment Entry : ${queryData?.subtenatName}`
                  : `${selectedCompany == 'Refund' ? 'Refund / Transfer / Withdraw Section' : selectedCompany == 'RefundAging' ? 'Refund Section' : selectedCompany == 'RefundFederal' ? 'Refund Section' : 'Payment Entry'} - ${isNotValidNullUndefile(props?.authToken) || isOtpVarified === true ? (selectedCompany != 'life_point_law' && selectedCompany != 'Refund' && selectedCompany != 'RefundAging' && selectedCompany != 'RefundFederal') ? currentCompany?.name : subtenantName :
                  (currentCompany?.name)}`}
                {/* Payment Entry - {currentCompany.name} */}
              </h1>
              {(!queryData || (queryData?.paymnetFromIntake !== "true" && queryData?.paymnetFromEventCoordinator  !== 'true')) && (
              <div className="flex gap-3">
            {showExcle == false && demo == true && selectedCompany != 'Refund' && <div className="">
            <button className="bg-[#720c20] text-white font-semibold py-2 px-2 rounded flex gap-2 justify-center items-center" onClick={()=>{openExcel(); setSubtenantIdExcel(selectedCompany); setSelectedCompany('');}}><img className="mt-0 pt-0" width="30px" src="/dashboardIcon1.png" />Dashboard</button>
            </div>}
              {!isNotValidNullUndefile(props?.authToken) && isClient !== true && selectedCompany != 'Refund' && <button
              // {/* {<button */}
                onClick={resetToCompanySelection}
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
              >
                Change Company
              </button>}
              {(isClient !== true) && (isReportViewable == true) && selectedCompany != 'Refund' &&
              userAccess?.isRecordAccess == true &&
              <button
                  className="px-2 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                  onClick={reportFunc}>
                  Report
                </button>}
              {(selectedCompany == 'life_point_law' || selectedCompany == 'Refund') && <button className="px-2 py-2 bg-[#720c20] text-white rounded-md hover:bg-[#720c20]" onClick={()=>{setSelectedCompany(selectedCompany == 'Refund'  ? 'life_point_law' :'Refund')}}>{selectedCompany == 'Refund' ? 'Back' : 'Refund / Transfer / Withdraw'}</button>}
              {(selectedCompany == 'aging_options' || selectedCompany == 'RefundAging') && <button className="px-2 py-2 bg-[#720c20] text-white rounded-md hover:bg-[#720c20]" onClick={()=>{setSelectedCompany(selectedCompany == 'RefundAging'  ? 'aging_options' :'RefundAging')}}>{selectedCompany == 'RefundAging' ? 'Back' : 'Refund'}</button>}
              {(selectedCompany == 'federal_way_plaza' || selectedCompany == 'RefundFederal') && <button className="px-2 py-2 bg-[#720c20] text-white rounded-md hover:bg-[#720c20]" onClick={()=>{setSelectedCompany(selectedCompany == 'RefundFederal'  ? 'federal_way_plaza' :'RefundFederal')}}>{selectedCompany == 'RefundFederal' ? 'Back' : 'Refund'}</button>}
              {userAccess?.isRefundAccess == true && (selectedCompany == 'life_point_law' || selectedCompany == 'Refund') && <RefundNotification setuseLoader={setuseLoader} setToast={setToast} onRefundUpdate={handleRefundUpdate} />}
              {userAccess?.isRefundAccess == true && (selectedCompany == 'aging_options' || selectedCompany == 'RefundAging') && <RefundNotification setuseLoader={setuseLoader} setToast={setToast} onRefundUpdate={handleRefundUpdate} />}
              {userAccess?.isRefundAccess == true && (selectedCompany == 'federal_way_plaza' || selectedCompany == 'RefundFederal') && <RefundNotification setuseLoader={setuseLoader} setToast={setToast} onRefundUpdate={handleRefundUpdate} />}
              </div>
            )}
            </div>
          </div>}
          <div>
            {/* Life Point Law Flow */}

            {(selectedCompany === 'life_point_law' || queryData?.paymnetFromIntake === "true" || queryData?.paymnetFromEventCoordinator == 'true') && (
              <LifepointLaw paymentData={paymentData}
                setPaymentData={setPaymentData}
                handleInputChange={handleInputChange}
                handleMatterNumberChange={handleMatterNumberChange}
                attorneys={attorneys}
                setSelectedUserData={setSelectedUserData}
                setuseLoader={setuseLoader}
                setToast={setToast}
                installmentpay={installmentpay}
                setInstallmentpay={setInstallmentpay}
                installmentAmount={installmentAmount}
                setInstallmentamount={setInstallmentamount}
                resetToCompanySelection={resetToCompanySelection}
                subtinentId={queryData?.paymnetFromIntake === "true" ? queryData?.clientParaData?.subtenantId : userRegistration ? SubtenantIde : queryData?.paymnetFromEventCoordinator  == 'true' ? queryData?.subtenantId : lplSubtinent}
                isHourlyIOALTA={queryData?.isHourlyIOALTA == "true"}
                PaymentOption={PaymentOption}
                setPaymentoption={setPaymentoption}
                handleScroll={handleScroll}
                resetToLifepaointdata={resetToLifepaointdata}
                timeMatter={timeMatter}
                setTimematter={setTimematter}
                paymentAccount={paymentAccount}
                setPaymentaccount={setPaymentaccount}
                isUpdated={isUpdated}
                userRegistration ={userRegistration}
                queryData={queryData}
                setPayLatter ={setPayLatter}
                trxnStatus={trxnStatus}
                splitCards={splitCards}
                setIsSplitpaymentsession={setIsSplitpaymentsession}
                splitPaymentno={splitPaymentno}
                userAuthSubIdState={userAuthSubIdState}
                setSelectedCompany={setSelectedCompany}
                setSplitcards={setSplitcards} setSplitPaymentno={setSplitPaymentno}
                setRecurringCard={setRecurringCard}
                queryData22={queryData22}
                setRecurringCardAMA={setRecurringCardAMA}
                setScheculeCard={setScheculeCard}
                otherSourceref={otherSourceref}
                addnewService={addnewService}
                setAddnewservice={setAddnewservice}
                scrollToSection={scrollToSection}
                servicetyperef={servicetyperef}
                />
              // <ExcleDashbord/>
            )}

            {selectedCompany === 'aging_options' && (
              <Agingoptions paymentData={paymentData} handleInputChange={handleInputChange} setSelectedUserData={setSelectedUserData} setPaymentData={setPaymentData} setuseLoader={setuseLoader} resetToCompanySelection={resetToCompanySelection} setToast={setToast}isUpdated={isUpdated} />
            )}


            {/* Federal Way Plaza Flow */}
            {selectedCompany === 'federal_way_plaza' && (
              <FederalWay paymentData={paymentData} handleInputChange={handleInputChange} setPaymentData={setPaymentData} setuseLoader={setuseLoader} setSelectedUserData={setSelectedUserData} setToast={setToast} />
            )}
            {selectedCompany == 'Refund' && <Refund paymentData={paymentData} setPaymentData={setPaymentData} setuseLoader={setuseLoader} setSelectedUserData={setSelectedUserData} subtinentId={queryData?.paymnetFromIntake === "true" ? queryData?.clientParaData?.subtenantId : userRegistration ? SubtenantIde : lplSubtinent} setToast={setToast}  timeMatter={timeMatter}
              setTimematter={setTimematter} setSelectedCompany={setSelectedCompany} addOrderUser={addOrderUser} resetToCompanySelection={resetToCompanySelection} resetToLifepaointdata={resetToLifepaointdata} refundRefreshTrigger={refundRefreshTrigger} />}
            {selectedCompany == 'RefundAging' && <Refund paymentData={paymentData} setPaymentData={setPaymentData} setuseLoader={setuseLoader} setSelectedUserData={setSelectedUserData} subtinentId={3} setToast={setToast}  timeMatter={timeMatter}
              setTimematter={setTimematter} setSelectedCompany={setSelectedCompany} addOrderUser={addOrderUser} resetToCompanySelection={resetToCompanySelection} resetToLifepaointdata={resetToLifepaointdata} refundRefreshTrigger={refundRefreshTrigger} />}
            {selectedCompany == 'RefundFederal' && <Refund paymentData={paymentData} setPaymentData={setPaymentData} setuseLoader={setuseLoader} setSelectedUserData={setSelectedUserData} subtinentId={federal_way_plazaId} setToast={setToast}  timeMatter={timeMatter}
              setTimematter={setTimematter} setSelectedCompany={setSelectedCompany} addOrderUser={addOrderUser} resetToCompanySelection={resetToCompanySelection} resetToLifepaointdata={resetToLifepaointdata} refundRefreshTrigger={refundRefreshTrigger} />}
            {/* {paymentData?.paymentMethod == 'credit' && <div className="bg-white rounded-lg shadow-md p-6 mt-5">
            <p>Do you want to schedule your installment via?</p>
            <div className="relative flex gap-3 mt-1">
            {radioButton('Card','Card',scheduleCard,setScheculeCard)}
            {radioButton('Cash','Cash',scheduleCard,setScheculeCard)}
            </div>
            </div>} */}
            {((selectedCompany === 'life_point_law' && paymentData?.paymentMethod == 'credit') || (queryData?.paymnetFromIntake === "true" && paymentData?.paymentMethod == 'credit')) && (queryData?.paymnetFromEventCoordinator !== 'true') && <div className="bg-white rounded-lg shadow-md p-6 mt-5">
            <h2 className="text-[18px] font-semibold">Split Payment</h2>
            <p className="mt-2">Would you like to pay using multiple cards?</p>
            <div className="relative flex gap-3 mt-1">
            {radioButton('Yes','Yes',splitPaymentno,setSplitPaymentno)}
            {radioButton('No','No',splitPaymentno,setSplitPaymentno)}
            </div>
              {splitPaymentno == 'Yes' && splitCards?.map((card, index) => (
                <div key={card.id || index} className="w-[90%] mb-3 flex items-center gap-3 mt-2 border-b-[1.4px] py-2">
                  <p className="w-20 font-semibold">Card {index + 1}</p>
                  <p>Amount:</p>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                    <span className="text-gray-500">$</span>
                  </div>
                  <input
                    type="type"
                    label="Amount"
                    placeholder="Enter amount"
                    value={formatToUS(card.amount) || ''}
                    onChange={(e) => handleSplitInputChange(e,index)}
                    className="border py-2 rounded w-32 pl-6"
                    // disabled={(issplitPaymentSession) ? true : false}
                    disabled={paymentData?.splitCardnumber >= card?.id ? true : false}
                  />
                  </div>
                  <div className="flex mt-2">
                          {chackboxButton('General Account', 1, card, setSplitcards, splitCards, paymentData, setToast)}
                          {chackboxButton('IOLTA Account', 2, card, setSplitcards, splitCards, paymentData, setToast)}
                        </div>
                  {/* {errorMesSplit && card.id == index+1 && <p>{errorMesSplit}</p> } */}
                  {paymentData?.splitCardnumber >= card.id ? <p>Payment Completed</p>:<button disabled={paymentData?.splitCardnumber ? card.id  != paymentData?.splitCardnumber+1 : card.id  != 1} className={`bg-green-600 text-white px-2 py-2 rounded hover:bg-green-700 ${(paymentData?.splitCardnumber ? card.id  != paymentData?.splitCardnumber+1 : card.id  != 1 ) ? '!bg-gray-800 !hover:bg-gray-1000 cursor-not-allowed' : false}`} onClick={()=>{handleSplitPayment(card,index)}}>
                    Process Payment
                  </button>}
                  {/* {splitCards?.length > index + 1 && (paymentData?.splitCardnumber >= index+1 ? '' : <button
                    onClick={() =>{
                      setSplitcards((prev) => [
                        ...prev?.filter((f)=> f.id != card.id)
                      ])
                    }}
                    className="bg-red-600 text-white px-2 py-1 rounded hover:bg-red-700"
                  >
                  -
                  </button>)} */}
                  {PaymentOption == 2 && <div>
                  <input type="checkbox" placeholder="Select card for recurring payment." onChange={(e)=>{
                    setRecurringCard(e.target.checked == true ? card.id : '')
                    const updated = splitCards?.map((c, i) =>i === index ? { ...c, installmentcard:true } : c);
                    setSplitcards(updated);
                    }} checked={recurringCard != '' && recurringCard == card.id ? true : false} disabled={(recurringCard != '' && recurringCard != card.id) || (paymentData?.splitCardnumber >= card.id)} className={`${(paymentData?.splitCardnumber >= card.id) ? 'cursor-not-allowed opacity-50' : ''}`} />
                  <span className={`ms-1 ${(paymentData?.splitCardnumber >= card.id) ? 'opacity-50 text-gray-400' : ''}`}>Select the card for installments scheduled</span>
                  </div>}

                  {(scheduleCard == 'true' || scheduleCard == true) && <div className="d-flex gap-2">
                  {["AMA&Fee","onlyProbate","onlyFee"].includes(queryData?.subscriptionType) && queryData?.subsDetails?.length > 0 && (queryData?.subsDetails[0].isInstallmentPlan == false || queryData?.subsDetails[0].isInstallmentPlan == null) && !isNotValidNullUndefileInstallmentAmount(queryData?.subsDetails[0].installmentAmount) ? '' : <div>
                  <input type="checkbox" placeholder="Select card for recurring payment." onChange={(e)=>{
                    setRecurringCardAMA(e.target.checked == true ? card.id : '')
                    const updated = splitCards?.map((c, i) =>i === index ? { ...c, installmentcardAMA:true } : c);
                    setSplitcards(updated);
                    }} checked={recurringCardAMA != '' && recurringCardAMA == card.id ? true : false} disabled={(recurringCardAMA != '' && recurringCardAMA != card.id) || (paymentData?.splitCardnumber >= card.id)} className={`${(paymentData?.splitCardnumber >= card.id) ? 'cursor-not-allowed opacity-50' : ''}`} />
                  <span className={`ms-1 ${(paymentData?.splitCardnumber >= card.id) ? 'opacity-50 text-gray-400' : ''}`}>Select the card for installments scheduled</span>
                  </div>}

                  {["AMA&Fee"].includes(queryData?.subscriptionType) && queryData?.installmentAmountAMA && <div>
                  <input type="checkbox" placeholder="Select card for recurring payment." onChange={(e)=>{
                    setRecurringCardAMAfee(e.target.checked == true ? card.id : '')
                    const updated = splitCards?.map((c, i) =>i === index ? { ...c, installmentcardAMAfee:true } : c);
                    setSplitcards(updated);
                    }} checked={recurringCardAMAfee != '' && recurringCardAMAfee == card.id ? true : false} disabled={(recurringCardAMAfee != '' && recurringCardAMAfee != card.id) || (paymentData?.splitCardnumber >= card.id)} className={`${(paymentData?.splitCardnumber >= card.id) ? 'cursor-not-allowed opacity-50' : ''}`} />
                  <span className={`ms-1 ${(paymentData?.splitCardnumber >= card.id) ? 'opacity-50 text-gray-400' : ''}`}>Select the card for installments scheduled for AMA.</span>
                  </div>}
                  </div>}
                  {(splitCards?.length == index + 1) && <button
                    onClick={() =>{
                      if(isProcessing) {
                        setToast({ message: 'Please wait for the current payment to complete before adding a new card.', type: 'error' });
                        return;
                      }
                      // Check if we need to wait for payment completion
                      // For the first card (id=1), we need at least 1 payment completed to add second card
                      // For subsequent cards, we need the previous card payment completed
                      const completedPayments = paymentData?.splitCardnumber || 0;
                      if(completedPayments < card.id) {
                        setToast({ message: 'Please complete the current card payment before adding a new card.', type: 'error' });
                        return;
                      }
                      if(totalSplit == paymentData.amount){
                        setToast({ message: `The total amount is already allocated to the card.`, type: "error" });
                        return;
                      }
                      setSplitcards((prev) => [
                        ...prev,
                        { id: prev?.length + 1, amount: 0 },
                      ])
                    }
                    }
                    disabled={false}
                    className={`px-2 py-1 rounded ${
                      isProcessing || (paymentData?.splitCardnumber || 0) < card.id
                        ? 'bg-gray-400 text-white cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    }`}
                  >
                    +
                  </button>}
                </div>
              ))}
            </div>}
            {/* {console.log(splitCards,"splitCardsrecurringCard",recurringCard,paymentData,"splitPaymentno",splitPaymentno)}
            {console.log(queryData,"queryData",scheduleCard,"scheduleCard")}
            {console.log(confirmOrderDetails,"confirmOrderDetails")} */}
            {(selectedCompany === 'life_point_law' || queryData?.paymnetFromIntake === "true") && (splitPaymentno == 'Yes' ? <></> :((!paymentData?.splitAmount && isClient !== true) || queryData?.paymnetFromIntake === "true") && <div className="bg-white rounded-lg shadow-md p-6 mt-4">
            <h2 className="block text-sm font-medium text-gray-700 mb-1">This payment will go to?</h2>
            <div className="relative flex gap-6">
              {chackboxButtonAccount('General Account', 1, paymentAccount, setPaymentaccount)}
              {chackboxButtonAccount('IOLTA Account', 2, paymentAccount, setPaymentaccount)}
            </div>
          </div>)}

            {/* Payment Method Section (Common to all companies) */}

            {userRegistration !== true && selectedCompany != 'Refund' && selectedCompany != 'RefundAging' && selectedCompany != 'RefundFederal' && <div className="bg-white rounded-lg shadow-md p-6 mt-5" ref={scrollRef}>
              <div className="flex justify-between items-center">
                <div className="text-lg font-semibold">
                  {/* Total Amount: ${`${paymentData?.amount?.toFixed(2) || '0.00'}`} */}
                  Total Amount: ${`${formatToUS(queryData?.paymnetFromEventCoordinator == 'true' ? queryData?.totalCost : paymentData?.amount) || '0.00'}`}
                </div>
                <div className="space-x-4">
                  <button
                    type="button"
                    onClick={() => {
                      // resetToCompanySelection();
                      redirectToIntake(false, '');
                      resetToLifepaointdata()
                    }}
                    className={`px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 ${splitPaymentno == 'Yes' ? '!bg-gray-800 !hover:bg-gray-1000 cursor-not-allowed' : false}`}
                    disabled={splitPaymentno == 'Yes' ? true : false}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleSubmit()}
                    type="submit"
                    className={`px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 ${splitPaymentno == 'Yes' ? '!bg-gray-800 !hover:bg-gray-1000 cursor-not-allowed' : false} }`}
                    disabled={splitPaymentno == 'Yes' ? true : false}

                  >
                    Process {PaymentOption == 2 && installmentpay == 2 ? 'Installment' : 'Payment'}
                  </button>
                </div>
              </div>
            </div>}
          </div>
        </div>
      </div>

      {openRecipetModal && returnPaymentRecipet()}
      {orderIdData && paymentData?.paymentMethod !== "cash" && installmentpay != 2 && showAddCard == false && <PaymentGateWay queryData={queryData} orderIdData={orderIdData} primaryUserId={selectedUserData?.memberId} />}
      {toast && (<Toaster message={toast.message} type={toast.type} onClose={() => setToast(null)}/>)}
      {(((((((showAddCard == true && PaymentOption == 2) || (orderIdData == true && installmentpay == 2 && paymentData?.paymentMethod == "credit" && PaymentOption == 2)) || (queryData?.paymnetFromIntake === "true" && ["onlyAMA", "AMA&Fee"].includes(queryData?.subscriptionType) && !((queryData?.subscriptionType === "onlyFee" && queryData?.clientOrderDetails?.totalCost !== queryData?.clientOrderDetails?.paidAmt) || (["onlyFee", "onlyProbate","onlyAMA"].includes(queryData?.subscriptionType) && queryData?.totalInstallment > 0)) && PaymentOption == 1 && showAddCard))) || ((["onlyFee", "onlyProbate","onlyAMA"].includes(queryData?.subscriptionType) && (Number(queryData?.totalInstallment) > 0 || Number(queryData?.subsDetails?.[0]?.totalInstallment) > 0)) && PaymentOption == 1 && showAddCard)) || (queryData?.paymnetFromIntake === "true" && ["AMA&Fee"].includes(queryData?.subscriptionType) && PaymentOption == 1 && showAddCard)) || (sessionStorage.getItem('isAdvancePayment') === 'true' && showAddCard == true)) && <CardDetails queryData={queryData} selectedUserData={selectedUserData} setInstallmentpay={setInstallmentpay} clientData={selectedUserData} formData={paymentData}
      funForOrderIdUpdate={()=>setOrderIdData(false)} installmentAmount={installmentAmount} setToast={setToast} setOrderIdData={setOrderIdData} resetToCompanySelection={resetToCompanySelection} setShowaddcard={setShowaddcard} showAddCard={showAddCard} userAuthSubs={userAuthSubs} orderIdData={orderIdData} setuseLoader={setuseLoader} afterPaymentFlow={afterPaymentFlow} /> }
    </>
  );
};






export default Dashboard;